/** @flow */
import tooltipsTranslations from "@modules/service/tooltips-translations";

export const serviceMessages = {
  en: {
    DRAFT_CREATED: "Draft was successfully created",
    DRAFT_UPDATED: "Draft was successfully updated",
    REASON_SCRIPT_CREATED: "Reason Specific Script was created successfully",
    REASON_SCRIPT_UPDATED: "Reason Specific Script was updated successfully",
    SUCCESSFULLY_UPDATED: "Successfully updated",
    DRAFT_SUBMITTED: "Draft was submitted for review successfully",
    DRAFT_DISCARDED: "Draft was discarded successfully",
    DRAFT_CANCELED: "Draft was cancelled successfully",
    DRAFT_CANCELED_AND_DISCARDED: "Draft was cancelled and discarded successfully",
    ABSENCE_REASON_CREATED: "Absence Reason was created successfully",
    ALERT_ATTACHMENT_ADDED: "Alert attachment added successfully",
    ALERT_ATTACHMENT_REMOVED: "Alert attachment removed successfully",
    DEPARTMENT_SCRIPT_CREATED: "Department Specific Script was created successfully",
    HIERARCHY_SCOPE_UPDATED: "Hierarchy scope was updated successfully",
    DYNAMIC_QUESTION_CREATED: "Dynamic Question was created successfully",
    EMAIL_CONTROL_SETTINGS_UPDATED: "Email Controls Settings successfully updated",
    EMAIL_NOTIFICATION_CREATED: "Email notification was successfully created",
    EMAIL_NOTIFICATION_UPDATED: "Email notification was successfully updated",
    EMAIL_NOTIFICATION_REMOVED: "Email notification was successfully removed",
    EMPLOYEE_IDENTITY_SETTINGS_UPDATED: "Employee Identity Settings successfully updated",
    SMS_WELLNESS_PROMPT_CREATED: "SMS Wellness Prompt was successfully created",
    SMS_WELLNESS_PROMPT_UPDATED: "SMS Wellness Prompt was successfully updated",
    SMS_WELLNESS_PROMPT_REMOVED: "SMS Wellness Prompt was successfully removed",
    EMPLOYEE_SMS_SETTINGS_UPDATED: "Employee SMS notifications successfully updated",
    SECURITY_SETTINGS_UPDATED: "The security setting were updated.",
    STAFF_GROUP_ADDED: "Staff Group was successfully added",
    STAFF_GROUP_UPDATED: "Staff Group was successfully updated",
    STAFF_GROUP_ENABLED: "Staff Group was successfully enabled",
    STAFF_GROUP_SAVED: "Staff Group Configuration was successfully saved",
    PAGER_RESTRICTION_CREATED: "Pager restriction was successfully created",
    PAGER_RESTRICTION_UPDATED: "Staff Group Configuration was successfully updated",
    PAGER_RESTRICTION_DELETED: "Staff Group Configuration was successfully deleted",
    SMS_RESTRICTION_CREATED: "SMS restriction was successfully created",
    SMS_RESTRICTION_UPDATED: "SMS restriction was successfully updated",
    SMS_RESTRICTION_DELETED: "SMS restriction was successfully deleted",
    REPORTING_PARAMETERS_UPDATED: "Reporting Parameters were successfully updated",
    EXCLUDED_REASON_CREATED: "Reason to be excluded was successfully created",
    EXCLUDED_REASON_UPDATED: "Reason to be excluded was successfully updated",
    EXCLUDED_REASON_DELETED: "Reason to be excluded was successfully deleted",
    SELECTED_EXCLUDED_REASONS_DELETED: "Selected reasons to be excluded were successfully deleted",
    RTW_ATTACHMENT_ADDED: "Rtw attachment added successfully",
    RTW_ATTACHMENT_REMOVED: "Rtw attachment removed successfully",
    SERVICE_SETTINGS_UPDATED: "Service Settings successfully updated",
    CHANGE_SET_DELETED: "Change set was successfully deleted",
    SELECTED_CHANGE_SETS_DELETED: "Selected change sets were successfully deleted",
    SHIFT_CREATED: "Shift was successfully created",
    SHIFT_UPDATED: "Shift was successfully updated",
    CUSTOM_CONTACT_CREATED: "Custom special contact type was successfully created",
    CUSTOM_CONTACT_UPDATED: "Custom special contact type was successfully updated",
    CUSTOM_CONTACT_REMOVED: "Custom special contact type was successfully removed",
    SPECIAL_CONTACT_CREATED: "Special contact was successfully created",
    SPECIAL_CONTACT_UPDATED: "Special contact was successfully updated",
    SPECIAL_CONTACT_REMOVED: "Special contact was successfully removed",
    STANDARD_QUESTION_CREATED: "Standard Question was successfully created",
    STANDARD_QUESTION_UPDATED: "Standard Question was successfully updated",
    SYSTEM_SETTINGS_UPDATED: "System Settings successfully updated",
    BULK_REGISTRATION_EMAILS_SENT: "Bulk Registration Emails were successfully sent",
    EMPLOYEE_EMAILS_SENT: "Employee Emails were successfully sent",
    REGISTRATION_EMAILS_UPDATED: "Registration emails successfully updated",
    SUCCESSFULLY_REASSIGNED: "Successfully reassigned!",
    SUCCESSFULLY_UNASSIGNED: "Successfully unassigned!",
    UPLOAD_LOGO_SUCCESS: "Logo was successfully uploaded",
    USER_PERMISSIONS_UPDATED: "User permissions were successfully updated",
    NURSE_DECLINED_REASON_CREATED: "Nurse Declined Reason was created successfully",
    NURSE_DECLINED_REASON_UPDATED: "Nurse Declined Reason was updated successfully",
    ABSENCE_MONITORING_PROCESS_CREATED: "Absence Monitoring Process was created successfully",
    ABSENCE_MONITORING_PROCESS_UPDATED: "Absence Monitoring Process was updated successfully",
    REFERRAL_PROCESS_CREATED: "Referral Process was created successfully",
    REFERRAL_PROCESS_UPDATED: "Referral Process was updated successfully",
    DYNAMIC_QUESTION_CREATED: "Dynamic Question was created successfully",
    DYNAMIC_QUESTION_UPDATED: "Dynamic Question was updated successfully",
    ABSENCE_AUDITS_EXPORTED: "Absence Audit Logs were successfully exported",
    NOTIFICATION_AUDITS_EXPORTED: "Notification Audit Logs were successfully exported",
    ABSENCE_ACCESS_AUDITS_EXPORTED: "Absence Access Audit Logs were successfully exported",
  },
};

export default {
  en: {
    ...tooltipsTranslations.en,
    REASONS_FOR_DECLINING: "Reasons for Declining:",
    NEXT_STEPS_INSTRUCTIONS: "Next Steps Instructions:",
    ADD_ALERT: "Add Alert",
    EVENTS: "Events",
    ALERT_TRIGGERS: "Alert Triggers",
    RETURN_TO_WORKS: "Return To Works",
    RTW_FORMS: "RTW Forms",
    ABSENCE_REASONS: "Absence Reasons",
    CLASSIFICATIONS: "Classifications",
    PROMPTS: "Prompts",
    ADDED_BY: "Added By",
    CANCEL: "Cancel",
    DATE_CREATED: "Date Created",
    DATE_ADDED: "Date Added",
    DURATION: "Duration",
    EDIT: "Edit",
    DELETE: "Delete",
    EDIT_LIVE: "Edit Live",
    EMPLOYEE_USE: "Employee Use",
    EXISTING_SHIFT_PATTERN: "Existing Shift Patterns",
    PLANNED_LEAVE: "Planned Leave",
    SCHEDULED_REPORTS_TUTORIAL: "Scheduled Reports Tutorial",
    SERVICE_CONFIGURATION: "Service Configuration",
    PLANNED_LEAVE_TASKS: "Planned Leave Tasks",
    ADD_NEW_TASK: "Add New Task",
    LEAVE_TYPE: "Leave Type",
    PLANNED_LEAVE_CONFIGURATION: "Planned Leave Configuration",
    ADD_NEW_NURSE_DECLINED_REASON: "Add New Nurse Declined Reason",
    ENTER_A_NEW_NURSE_DECLINED_REASON: "Enter a new Nurse Declined Reason",
    DISABLE_REASON: "Disable Reason",
    NON_MEDICAL_ABSENCE: "Non-Medical Absence",
    ABSENCE_REASON_CLASSIFICATIONS: "Absence Reason Classifications",
    ADD_NEW_ABSENCE_REASON: "Add New Absence Reason",
    ABSENCE_TYPE: "Absence Type",
    STATUS: "Status",
    ACTIONS: "Actions",
    YES: "Yes",
    NO: "No",
    UPDATE: "Update",
    DISABLE: "Disable",
    NOT_REQUIRED: "-",
    DRAFT: "Draft",
    LIVE: "Live",
    PARENT_REASON: "Parent Reason",
    NURSE_TRANSFER_ELIGIBILITY: "Nurse Transfer Eligibility",
    DISPLAY_NAME: "Display Name",
    TASK_DESCRIPTION: "Task Description",
    KPI_TARGET: "KPI Target",
    KPI_TARGET_DAYS: "KPI Target (Days)",
    KPI_TARGET_HOURS: "KPI Target (Hours)",
    EFFECTIVE_FROM: "Effective From",
    EFFECTIVE_TO: "Effective To",
    INVALID_DATE: "Invalid Date",
    EXCLUDE_FROM_IS_AFTER_TO: "Exclude to date should be after exclude from date",
    GENERAL: "General",
    SPECIFIC_REASONS: "Specific Reasons",
    SECURITY: "Security",
    SYSTEM_ACCESS: "System Access",
    CALL_FLOW: "Call Flow",
    STANDARD_SCRIPTS: "Standard Scripts",
    SCRIPTS: "Scripts",
    STANDARD: "Standard",
    STANDARD_QUESTIONS_TOOLTIP:
      "Standard questions form part of an absence interaction. They are asked of the employee by our advisor at specific junctions within the overall call flow, and are intended to facilitate the capture of vital additional information relevant to the absence itself. By nature, standard questions are not customisable (in the sense that the purpose and functioning of the question cannot be made bespoke), however, certain aspects of a standard question are easily updated by selecting the 'Edit' button. Draft changes can be saved and, when ready, submitted for approval by a GoodShape representative.  Note, it is not possible to implement a change if a pending change request is already in process.",
    DYNAMIC: "Dynamic",
    QUESTIONS: "Questions",
    SIMULATE_QUESTIONS: "Simulate Questions",
    ALERTS_AND_NOTIFICATIONS: "Alerts & Notifications",
    MANAGER_SMS: "SMS Notifications",
    PROCESSES: "Processes",
    SERVICE_SUMMARY: "Service Summary",
    ALWAYS: "Always",
    NEVER: "Never",
    ABSENCE_DURATION_DEPENDENT: "Absence duration dependent",
    SEARCH_BY_SURNAME: "Search by Surname",
    ABSENCE_REASON_ADD_SUCCESS: "Abasence reason was successfully added",
    ABSENCE_REASON_EDIT_SUCCESS: "Abasence reason was successfully updated",
    HOME_MOBILE: "Phone Number",
    EMPLOYEE_REF_PRIMARY: "Employee Ref",
    SEARCH_EMPLOYEE_BY_SURNAME: "Search Employee by Surname",

    // SERVICE SETTINGS
    SERVICE_SETTINGS: "Service Settings",
    SETTINGS: "Settings",
    SERVICE_SETTINGS_DRAFT: "Draft for Service Settings",
    SERVICE_SETTINGS_LOCKED: "This draft is locked and cannot be edited as it is pending review.",
    SERVICE_SETTINGS_LAST_UPDATED_BY: "Last edited by:",
    SERVICE_SETTINGS_START_DRAFT: "Start Draft",
    SERVICE_SETTINGS_SUBMIT_CHANGES: "Submit Changes",
    SERVICE_SETTINGS_SAVE: "Save",
    SERVICE_SETTINGS_ABSENCE_RECORDING: "Absence Recording",
    SERVICE_SETTINGS_ABSENCE_TYPE: "Absence Type",
    SERVICE_SETTINGS_MINIMUM_ABSENCE: "Minimum Absence (minutes)",
    SERVICE_SETTINGS_MINIMUM_ABSENCE_DURATION: "Minimum Absence Duration (minutes)",
    SERVICE_SETTINGS_TIME_IN_ADVANCE_ABSENCES_CAN_CLOSE:
      "Time in Advance Absences Can Close (Hours)",
    SERVICE_SETTINGS_ABSENCE_RECORDING_UNITS: "Absence Recording Units",
    SERVICE_SETTINGS_INCLUDE_FIT_DATE_CAPTURE: "Include Fit Date Capture",
    SERVICE_SETTINGS_RTW_DISCUSSION_TYPE: "RTW Discussion Type",
    SERVICE_SETTINGS_ALLOW_EMPLOYEES_TO_REOPEN_ABSENCES: "Allow Employees to Re-Open Absences",
    SERVICE_SETTINGS_TIME_PERIOD_IN_WHICH_ABSENCES_CAN_BE_REOPENED:
      "Time period in which absences can be re-opened (Calendar Days)",
    SERVICE_SETTINGS_TIME_IN_ADVANCE_AN_ABSENCE_CAN_BE_OPENED:
      "Time in advance an absence can be opened (Calendar Days)",
    SERVICE_SETTINGS_CAPTURE_ABSENCE_ON_BANK_HOLIDAYS: "Capture Absence on Bank Holidays",
    SERVICE_SETTINGS_PHASED_RTW_DAYS_RECORDING: "Phased RTW days recording?",
    SERVICE_SETTINGS_TASK_KPIS_EXCLUDE_BANK_HOLIDAYS: "Task KPI's Exclude Bank Holidays",
    SERVICE_SETTINGS_TASK_KPIS_EXCLUDE_WEEKENDS: "Task KPI's Exclude Weekends",
    SERVICE_SETTINGS_NON_MEDICAL_ABSENCE: "Non-Medical Absence",
    IMPORTANT_ANNOUNCEMENT: "Important Announcement",
    IMPORTANT_REMINDER: "Important Reminder",
    NON_MEDICAL_RULE: "Non-Medical",
    MIN_DURATION: "Min Duration",
    ADVANCED_CLOSE: "Advanced Close",
    ADVANCED_OPEN: "Advanced Open",
    RE_OPEN_ABSENCE: "Re-Open Absence",
    RE_OPEN_PERIOD: "Re-Open Period",
    BANK_HOLIDAYS: "Bank Holidays",
    KPI_EXCLUDE_HOLIDAYS: "Exclude Bank Holidays from KPI Targets",
    KPI_EXCLUDE_WEEKENDS: "Exclude Weekends from KPI Targets",
    ANNOUNCEMENT: "Announcement",
    PLATFORM: "Platform",
    APP_FEATURES: "App Features",

    // EMAIL NOTIFICATIONS
    EMAIL_NOTIFICATIONS: "Email Notifications",
    EMAIL_NOTIFICATION_PROFILE: "Email Notification Profile #{id}",
    EMAIL_NOTIFICATION_PROFILE_ID: "Profile ID",
    EMAIL_NOTIFICATION_PROFILE_NAME: "Email Profile Name",
    EMAIL_NOTIFICATION_HIIERARCHY_SCOPE: "Hierarchy Scope",
    HIERARCHY_SCOPE: "Hierarchy Scope",
    HIERARCHY_ASSIGNMENT: "Hierarchy Assignment",
    EMAIL_NOTIFICATION_DATE_ADDED: "Date Added",
    EMAIL_NOTIFICATION_ADDED_BY: "Added By",
    EMAIL_NOTIFICATION_STATUS: "Status",
    EMAIL_NOTIFICATION_ADD_TITLE: "New Email Profile",
    EMAIL_NOTIFICATION_EDIT_TITLE: "Email Notification Profile #{id}",
    EMAIL_NOTIFICATION_DELETE_TITLE: "Delete Email Profile",
    EMAIL_NOTIFICATION_DELETE_QUESTION: "Are you sure you want to delete email profile {id}?",
    EMAIL_NOTIFICATION_DELETE_SUBMIT_TEXT: "Delete Profile",
    EMAIL_NOTIFICATION_STEP1: "Content",
    EMAIL_NOTIFICATION_STEP1_MAIN_DETAILS: "Main Details",
    EMAIL_NOTIFICATION_STEP1_EMAIL_INFO: "Info to Be Included in Email Notification",
    EMAIL_NOTIFICATION_STEP1_DEFAULT_INSTRUCTIONS: "Default Instructions",
    EMAIL_NOTIFICATION_STEP1_NEXT_BUTTON: "Next Reason Specific Instructions",
    EMAIL_NOTIFICATION_STEP2: "Reason Instructions",
    EMAIL_NOTIFICATION_STEP2_NEXT_BUTTON: "Next Distribution Rules",
    EMAIL_NOTIFICATION_STEP3: "Distribution Rules",
    EMAIL_NOTIFICATION_STEP4: "Hierarchy Scope",
    EMAIL_NOTIFICATION_EMAIL_DISTRIBUTION_NAME: "Name",
    EMAIL_NOTIFICATION_REASON: "Reason",
    EMAIL_NOTIFICATION_ABSENCE_REASON: "Absence Reason",
    EMAIL_NOTIFICATION_INSTRUCTION_TEXT: "Instruction Text",
    EMAIL_NOTIFICATION_LAST_UPDATED: "Last Updated",
    EMAIL_NOTIFICATION_LAST_UPDATED_BY_TEXT: "Update {date} By {name}",
    EMAIL_NOTIFICATION_EMAIL_DISTRIBUTION_TYPE: "Email Distribution Type",
    EMAIL_NOTIFICATION_STARTS_NOTIFICATIONS: "Start Notifications",
    EMAIL_NOTIFICATION_BATCH_FREQUENCY: "Batch Frequency",
    EMAIL_NOTIFICATION_HIERARCHY_SCOPE: "Hierarchy Scope",
    EMAIL_NOTIFICATIONS_SECTION_EMPTY: "This section has not been completed yet.",
    AFTER_EVERY_ABSENCE: "After Every Absence",
    INCLUDE_RTW_DETAILS_IN_NOTIFICATIONS: "Include RTW Details in Absence Notifications",
    INCLUDE_RTW_DETAILS: "Include RTW Details",
    INCLUDE_ALERTS: "Include Alerts",
    INCLUDE_ALERTS_IN_NOTIFICATIONS: "Include Alerts In Absence Notifications",

    // MANAGER SMS PAGER NOTIFICATIONS
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_TITLE: "Manager SMS Notifications",
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_ADD_TITLE: "New {type} Rule",
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_ADD_STEP_1_NEXT_BUTTON: "Next: Hierarchy Area",
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_EDIT_TITLE: "Edit {type} Rule",
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_DELETE_TITLE: "Delete {type} Rule",
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_DELETE_QUESTION:
      "Are you sure you want to delete {type} {id}?",
    MANAGER_SMS_PAGER_NOTIFICATION_RULE_DELETE_SUBMIT_TEXT: "Delete {type} Rule",

    MANAGER_SMS_NOTIFICATIONS_MODAL_ADD_TITLE: "New {type} Rule",
    MANAGER_SMS_NOTIFICATIONS_MODAL_EDIT_TITLE: "{type} Rule {id}",
    MANAGER_SMS_NOTIFICATIONS_MODAL_STEP1_TITLE: "Main Details",
    MANAGER_SMS_NOTIFICATIONS_MODAL_STEP2_TITLE: "Hierarchy Areas",
    MANAGER_SMS_NOTIFICATIONS_MODAL_EDIT_BUTTON: "Save {type} Rule",

    MANAGER_SMS_NOTIFICATIONS_TEXT: "Absence Notifications",
    MANAGER_SMS_NOTIFICATIONS_RULE_ID: "Rule ID",
    MANAGER_SMS_NOTIFICATIONS_START_TIME: "SMS Start Time",
    MANAGER_SMS_NOTIFICATIONS_END_TIME: "SMS End Time",
    MANAGER_SMS_NOTIFICATIONS_INCLUDE_EMPLOYEE_REF: "Include Employee Ref",
    MANAGER_SMS_NOTIFICATIONS_INCLUDE: "Include",
    MANAGER_SMS_NOTIFICATIONS_DO_NOT_INCLUDE: "Do Not Include",
    MANAGER_SMS_HIERARCHY_AREAS: "Hierarchy Areas",
    MANAGER_SMS_DATE_ADDED: "Date Added",

    MANAGER_PAGER_NOTIFICATIONS_TITLE: "Pager Notifications",
    MANAGER_PAGER_NOTIFICATIONS_ADD_BUTTON: "Add New Pager Rule",
    MANAGER_PAGER_NOTIFICATIONS_ENABLED_TEXT: "Pager Notifications Enabled",
    MANAGER_PAGER_NOTIFICATIONS_DISABLED_TEXT: "Pager Notifications Disabled",
    MANAGER_PAGER_NOTIFICATIONS_RULE_ID: "Rule ID",
    MANAGER_PAGER_NOTIFICATIONS_START_TIME: "Pager Start Time",
    MANAGER_PAGER_NOTIFICATIONS_END_TIME: "Pager End Time",
    MANAGER_PAGER_HIERARCHY_AREAS: "Hierarchy Areas",
    MANAGER_PAGER_DATE_ADDED: "Date Added",

    MANAGER_SUCCESS_NOTIFICATION_MESSAGE: "{type} notifications successfully updated",
    MANAGER_TYPE_PAGER: "Pager",
    MANAGER_TYPE_SMS: "SMS",

    // EMPLOYEE SMS NOTIFICATIONS
    EMPLOYEE_SMS_NOTIFICATION_RULE_TITLE: "Employee SMS Notifications",
    EMPLOYEE_SMS_RULES_TITLE: "Employee SMS Rules",
    EMPLOYEE_SMS_OVERDUE_REMINDERS_TEXT: "Overdue Reminders",
    EMPLOYEE_SMS_TEXT_TO_CLOSE_TEXT: "Text To Close",

    EMPLOYEE_SMS_WELLBEING_PROMPTS_TITLE: "Wellbeing Notifications",
    EMPLOYEE_SMS_WELLBEING_ABSENCE_REASON: "Absence Reason",
    EMPLOYEE_SMS_WELLBEING_TEXT_MESSAGE: "Message",
    EMPLOYEE_SMS_WELLBEING_DATE_ADDED: "Date Added",
    EMPLOYEE_SMS_WELLBEING_STATUS: "Status",

    EMPLOYEE_SMS_MODAL_ADD_TITLE: "New Employee Text Prompt",
    EMPLOYEE_SMS_MODAL_EDIT_TITLE: "Edit Employee Text Prompt {id}",
    EMPLOYEE_SMS_MODAL_STEP1_TITLE: "Main Details",
    EMPLOYEE_SMS_MODAL_STEP2_TITLE: "Hierarchy Areas",
    EMPLOYEE_SMS_DELETE_TITLE: "Delete Employee Text Prompt",
    EMPLOYEE_SMS_DELETE_QUESTION: "Are you sure you want to delete {id}?",
    EMPLOYEE_SMS_DELETE_SUBMIT_TEXT: "Delete Prompt",

    // SHIFT PATTERNS
    SHIFT_PATTERNS: "Shift Patterns",
    ACTIVE_SHIFT_PATTERNS: "Active Shift Patterns",
    EDIT_SHIFT_PATTERN: "Edit Shift Pattern",
    SHIFT_PATTERN_NAME: "Shift Pattern Name",
    SHIFT_PATTERN_EMPLOYEES: "Employees",
    SHIFT_PATTERN_DEPARTMENTS: "Departments",
    SHIFT_PATTERN_CONFIGURE: "Configure",
    SHIFT_PATTERN_SPECIFY_PATTERN: "Specify Pattern",
    SHIFT_PATTERN_DATE: "Date",
    SHIFT_PATTERN_DAY_TYPE: "Day Type",
    SHIFT_PATTERN_TIME_TO_WORK: "Time Due To Work",
    SHIFT_PATTERN_ADD_TITLE: "Add New Shift Pattern",
    SHIFT_PATTERN_EDIT_TITLE: "Edit Shift Pattern",
    SHIFT_PATTERN_DELETE_TITLE: "Delete Shift Pattern",
    SHIFT_PATTERN_DELETE_QUESTION: "Are you sure you want to delete shift pattern {shiftName}?",
    SHIFT_PATTERN_WORKING_DAY: "Working Day",
    SHIFT_PATTERN_NON_WORKING_DAY: "Non-Working Day",
    SHIFT_PATTERNS_NO_DATA: "No shift patterns have been created.",
    EMPLOYEES_FOR_PATTERN: "Employees for Pattern: {patternName}",
    DEPARTMENTS_FOR_PATTERN: "Departments for Pattern: {patternName}",
    UNASSIGN_SELECTED: "Unassign Selected",
    REASSIGN_SELECTED: "Reassign Selected",
    SHIFT_PATTERN_FIELD_LABEL_NAME: "Shift Pattern",
    UNASSIGN: "Unassign",
    REASSIGN_EMPLOYEES_FROM_SHIFT_PATTERN:
      "Reassign {employeesCount} employee from the {shiftPatternName} shift pattern to:",
    REASSIGN_EMPLOYEES_FROM_SHIFT_PATTERN_plural:
      "Reassign {employeesCount} employees from the {shiftPatternName} shift pattern to:",
    REASSIGN_DEPARTMENTS_FROM_SHIFT_PATTERN:
      "Reassign {departmentsCount} department from the {shiftPatternName} shift pattern to:",
    REASSIGN_DEPARTMENTS_FROM_SHIFT_PATTERN_plural:
      "Reassign {departmentsCount} departments from the {shiftPatternName} shift pattern to:",
    UNASSIGN_EMPLOYEES_FROM_SHIFT_PATTERN:
      "Are you sure you want to unassign {employeesCount} employee from the {shiftPatternName} shift pattern?",
    UNASSIGN_EMPLOYEES_FROM_SHIFT_PATTERN_plural:
      "Are you sure you want to unassign {employeesCount} employees from the {shiftPatternName} shift pattern?",
    UNASSIGN_DEPARTMENTS_FROM_SHIFT_PATTERN:
      "Are you sure you want to unassign {departmentsCount} department from the {shiftPatternName} shift pattern?",
    UNASSIGN_DEPARTMENTS_FROM_SHIFT_PATTERN_plural:
      "Are you sure you want to unassign {departmentsCount} departments from the {shiftPatternName} shift pattern?",
    REASSIGN_DEPARTMENTS: "Reassign Departments",
    SELECT_SHIFT_PATTERN: "Select Shift Pattern",
    UNASSIGN_EMPLOYEES: "Unassign Employees",
    UNASSIGN_DEPARTMENTS: "Unassign Departments",
    SOMEONE_ELSE_NEED_TO_BE_INFORMED: "Someone else need to be informed?",
    WANT_TO_AUDIT_ALL_DEPARTMENT_CONTACTS: "Want to audit all Department Contacts?",

    // USER PERMISSIONS
    SORT_BY: "Sort by:",
    USER_PERMISSIONS: "User Permissions",
    MANAGEMENT_USERS: "Management Users",
    EMPLOYEE_USERS: "Employee Users",
    USERS: "Users",
    NEW_USERS: "New Users",
    EXISTING_USERS: "Existing Users",
    ONBOARDING_PERCENTAGE: "Onboarding %",
    ABSENCE_UPDATE_PERMISSIONS: "Absence Update Permissions",
    NOTIFICATION_ADMIN: "Notification Admin",
    NO_PERMISSIONS: "No Permissions",
    BOTH: "Both",
    MEDICAL_ONLY: "Medical Only",
    NONE: "None",
    NON_MEDICAL_ONLY: "Non Medical Only",
    AUTHORISED_TO_MAKE_CHANGES: "Authorised To Make Changes",
    CAN_REQUEST_CHANGES: "Can Request Changes",
    EXCLUDING_ABSENCES_FROM_ALERTS: "Exclude Absences From Alerts",
    ALLOW_MANAGER_TO_EDIT_EMPLOYEES_SHIFT_PATTERN: "Allow Manager Edit Employees Shift Pattern",
    EMPLOYEE_ACCOUNTS_PERMITTED: "Employee Accounts",
    BENCHMARKING_STATISTICS: "Benchmarking Statistics",
    ABSENCE_MONITORING_DETAILS: "Absence Monitoring Details",
    VIEW_COMPLETED_RTW_INTERVIEWS: "View RTW Forms",
    REPORT_ABSENCES: "Report Absences",
    UPDATE_ABSENCES: "Update Absences",
    PERMITTED_EXTENSION: "Permitted Extension",
    DAYS: "Days",
    DAYS_AND_HOURS: "Days and hours",
    WEEKS: "Weeks",
    MONTHS: "Months",
    CLOSE_ABSENCES: "Close Absences",
    EMPLOYEE_LED: "Employee Led",
    NURSE_LED: "Nurse Led",
    USER_ACCOUNTS: "User Accounts",
    ACCOUNT_CREATED: "Account Created",
    LATEST_LOGIN: "Latest Login",
    REGISTERED: "Registered",

    // STAFF GROUPS
    STAFF_GROUP: "Staff Group",
    TYPE: "Type",
    NUMBER_OF_EMPLOYEES_ASSIGNED: "Number of Employees Assigned",
    REMOVE_THIS_ASSIGNMENT: "Remove This Assignment",
    REASSIGN_TO_NEW_GROUP: "Reassign To New Group",
    REASSIGN_STAFF_GROUP: "Reassign Staff Group",
    REASSIGN_EMPLOYEES: "Reassign Employees",
    REASSIGN: "Reassign",
    REASSIGN_EMPLOYEES_TO_STAFF_GROUP:
      "Reassign {employeesCount} employees from {staffGroupName} Staff Group to:",
    SELECT_NEW_STAFF_GROUP: "Select New Staff Group",
    STAFF_GROUPS_CONFIGURATION: "Staff Groups Configuration",
    STAFF_GROUPS: "Staff Groups",
    NEW_STAFF_GROUP: "New Staff Group",
    ADD_NEW_STAFF_TYPE: "Add New Staff Type",
    STAFF_GROUP_NAME: "Staff Group Name",
    STAFF_GROUP_TYPE: "Staff Group Type",
    DISABLE_STAFF_GROUP: "Disable Staff Group",
    ENABLE_STAFF_GROUP: "Enable Staff Group",
    EDIT_STAFF_GROUP: "Edit Staff Group",
    UPDATE_STAFF_GROUP: "Update Staff Group",
    SUBMIT_CHANGES: "Submit Changes",
    // DATA SECURITY
    EMPLOYEE_IDENTITY: "Employee Identity",
    EMPLOYEE_IDENTIFICATIONS: "Employee Identifications",
    DATA_SECURITY: "Data Security",
    PASSWORD_RESET_REQUIREMENTS: "Password Reset Requirements",
    IP_ADDRESS_RESTRICTION: "IP Restrictions",
    ADD_NEW_IP_ADDRESS: "Add New IP Address",
    MFC_REGISTRATION_EMAILS: "GoodShapeCentral! Registration Emails",
    DISABLE_IP_ADDRESS: "Disable IP Address",
    RESTORE_IP_ADDRESS: "Restore IP Address",
    ADD_PERMITTED_IP_ADDRESS: "Add Permitted IP Address",
    ADD_IP_ADDRESS: "Add IP Address",
    DATE_OF_BIRTH: "Date of Birth",
    EMPLOYEE_REF: "Employee Ref",
    LAST_NAME: "Last name",
    SEND: "Send",
    MOTHERS_MAIDEN_NAME: "Mothers maiden name",
    PHONE_NUMBER: "Phone Number",
    RESET_QUESTION: "Allow Question Reset",
    DO_NOT_PROCEED: "Do not proceed with call",
    PROCEED_AND_NOTE: "Proceed with Call, noting incorrect answer",
    NAME_OF_BIRTH_PLACE: "What is the name of the city or town you were born in?",
    NAME_OF_FIRST_SCHOOL: "What is the name of your first school?",
    NAME_OF_PET: "What is the name of your pet?",
    MOTHER_MAIDEN_NAME: "What is your mother's maiden name?",
    NAME_OF_FIRST_COMPANY: "What was the name of the first company you worked in?",
    PERMITTED_TO_CREATE_NEW_EMPLOYEE: "Permitted To Create New Employee Records",
    NOTIFICATION_AUDIT_ENABLED: "Notification Audit Enabled",
    IDENTITY_VERIFICATION_CHECK: "Identity Verification Check",
    IDENTIFIERS: "Identifiers",
    EMPLOYEE_ACCESS_AUDIT: "Employee Access Audit",
    NOTIFICATION_AUDIT: "Notification Audit",
    AUDIT_FREQUENCY_DAYS: "Audit Frequency (Days)",
    SECURITY_QUESTIONS_ENABLED: "Security Questions Enabled",
    ACCESS_AUDIT: "Access Audit",
    AUDIT_FREQUENCY: "Audit Frequency",
    DISABLE_STAFF_GROUP_WARNING:
      "Employees are assigned to the {staffGroupName} Staff Group. What would you like to happen to the Staff Group assignment of these employees?",
    SECURITY_QUESTION_TOOLTIP:
      "This setting controls which 3 questions employees can choose from when they are setting up a security question on their account.",
    SECURITY_SETTINGS: "Security Settings",
    EMPLOYEE_ACCESS_AUDIT: "Employee Record Audit",
    EMAIL_SUPPRESSION: "Email Suppression",
    EMAIL_PRIVACY: "Email Privacy",
    EMAIL_HYPERLINKS: "Email Hyperlinks",
    EMAIL_HYPERLINKS_DESCRIPTION:
      "Hyperlinks are allowed to be included in the body of email notifications.",
    EMAIL_PRIVACY_DESCRIPTION:
      "A privacy flag will be included in absence notifications, so they are not shown to delegates with access to the recipient's mailbox.",
    EMAIL_SUPPRESSION_DESCRIPTION:
      "Block all personal identifiable data from appearing in absence notifications. Recipients will need to login to see the full details instead.",
    EMPLOYEE_AUDIT_FREQUENCY: "Employee Record Audit Frequency (Calendar Days)",
    EMPLOYEE_AUDIT_FREQUENCY_DESCRIPTION:
      "How frequently managers must perform an access audit. Only relevant if the Employee Record Audit is enabled.",
    EMPLOYEE_ACCESS_AUDIT_DESCRIPTION:
      "Block managers from accessing employee records until they complete an access audit.",
    MULTI_AUTH_DESCRIPTION:
      "Require all users to use two factor authentication to login to any GoodShape applications.",
    IP_RESTRICTION: "IP Restriction",
    IP_RESTRICTION_DESCRIPTION:
      "If enabled, users can only login to GoodShapeCentral from a device connected to an approved list of IP addresses.",
    RESTRICTED_LIST: "Restricted List",
    RESTRICTED_LIST_DESCRIPTION:
      "If enabled, an email address can only be saved to an employee record if it contains an approved domain.",

    // MFC CONFIG
    MFC_CONFIG: "MFC Config",

    // EMAIL CONTROLS
    HYPERLINKS: "Hyperlinks",
    SUPPRESSION: "Suppression",
    EMAIL_CONTROLS: "Email Controls",
    BETA: "Beta",
    ACCOUNT: "Account",
    ALLOW_HYPERLINKS_IN_INSTRUCTIONS: "Allow Hyperlinks In Instructions",
    CONTENT: "Content",
    EMAIL_DOMAINS: "Email Domains",
    EMAIL_DOMAIN: "Email Domain",
    DOMAINS: "Domains",
    EMAIL_DOMAIN_RESTRICTIONS: "Email Domain Restrictions",
    ADD_NEW_EMAIL_DOMAIN: "Add New Email Domain",
    RESTORE_EMAIL_DOMAIN: "Restore Email Domain",
    DISABLE_EMAIL_DOMAIN: "Disable Email Domain",
    ADD_APPROVED_EMAIL_DOMAIN: "Add Approved Email Domain",
    ADD_DOMAIN: "Add Domain",
    PERMITTED_EMAIL_DOMAIN: "Permitted Email Domain",
    DATE_DISABLED: "Date Disabled",
    SELECT: "Select",
    SUPRESS_ALL_EMAIL_CONTENT: "Supress all email content",
    ADD_EMAIL_DOMAIN: "Add Email Domain",
    EMAIL_DOMAIN_RESTRICTION_ACTIVE: "Email Domain Restriction Active",
    EMAIL_DOMAIN_RESTRICTION_INACTIVE: "Email Domain Restriction Inactive",

    // NURSE DECLINED REASONS
    NURSE_DECLINED_REASONS_APPROVABLE_TYPE: "Nurse Declined Reason",
    NURSE_DECLINED_REASONS: "Nurse Declined Reasons",
    NURSE_DECLINED_LOCKED_DEPENDENCIES:
      "This section is locked and cannot be edited due to a dependency.",
    DECLINED_REASON: "Declined Reason",
    NURSE_DECLINED_REASONS_LIVE_REASONS: "Live Reasons",
    NURSE_DECLINED_REASONS_LIVE_REASONS_FC: "Live Reasons",
    NURSE_DECLINED_REASONS_LIVE_REASONS_EMPTY: "No live reasons to review",
    NURSE_DECLINED_REASONS_LIVE_REASONS_EMPTY_FC: "No live reasons to review",
    NURSE_DECLINED_TITLE: "Nurse Declined",
    NURSE_DECLINED_REASONS_PENDING_REVIEW: "Reasons Pending Review",
    NURSE_DECLINED_REASONS_PENDING_REVIEW_FC: "Reasons Drafts Awaiting Review",
    NURSE_DECLINED_REASONS_PENDING_REVIEW_EMPTY: "No draft reasons pending review",
    NURSE_DECLINED_REASONS_PENDING_REVIEW_EMPTY_FC: "No drafts reasons awaiting review",
    NURSE_DECLINED_REASONS_DRAFT: "Draft Reasons",
    NURSE_DECLINED_REASONS_DRAFT_FC: "Client Draft Reasons",
    NURSE_DECLINED_REASONS_DRAFT_EMPTY: "No draft reasons to view",
    NURSE_DECLINED_REASONS_DRAFT_EMPTY_FC: "No client draft reasons to view",
    NURSE_DECLINED_REASONS_TABLE_NAME: "Nurse Declined Reason",
    NURSE_DECLINED_REASONS_TABLE_DATE_DISABLED: "Date Disabled",

    NURSE_DECLINED_REASON_DETAILS: "Reason #{reasonId}",
    NURSE_DECLINED_REASON_DETAILS_DRAFT: "Draft for Reason #{reasonId}",
    NURSE_DECLINED_REASON_DETAILS_LAST_UPDATED_BY: "Last edited by:",
    NURSE_DECLINED_REASON_EDIT_CURRENT_DRAFT: "Edit Current Draft",
    NURSE_DECLINED_REASON_SUBMIT_CHANGES: "Submit Changes",
    NURSE_DECLINED_REASON_CANCEL_REVIEW: "Cancel Review",
    NURSE_DECLINED_REASON_DETAILS_MAIN_DETAILS: "Main Details",
    NURSE_DECLINED_REASON_DETAILS_REASON_ID: "Reason Id",
    NURSE_DECLINED_REASON_DETAILS_REASON: "Reason",
    NURSE_DECLINED_REASON_DETAILS_STATUS: "Status",

    NURSE_DECLINED_REASON_ADD_TITLE: "New Reason",
    NURSE_DECLINED_REASON_EDIT_TITLE: "Edit Reason #{reasonId}",
    NURSE_DECLINED_REASONS_ACTION_START_SETUP_DRAFT: "Start Reason Draft",
    NURSE_DECLINED_REASONS_ACTION_VIEW_CURRENT_SETUP_DRAFT: "View Current Reason Draft",
    NURSE_DECLINED_REASONS_ACTION_EDIT_DETAILS: "Edit Details",
    NURSE_DECLINED_REASONS_ACTION_DUPLICATE_SETUP: "Duplicate Set-Up",
    NURSE_DECLINED_REASONS_ACTION_DISABLE_SETUP: "Disable Reason",
    NURSE_DECLINED_REASONS_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    NURSE_DECLINED_REASONS_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT:
      "Cancel Review and Discard Draft",
    NURSE_DECLINED_REASONS_ACTION_DISCARD_DRAFT: "Discard Draft",

    // WELLBEING_SERVICES
    SERVICES: "Services",
    PROVIDER_NAME: "Provider Name",
    SELECT_PROVIDER_NAME: "Select a provider name",
    SERVICE_TYPES: "Service Types",
    ADD_SETUP: "Add Set-Up",

    EAP_DETAILS_TITLE: "EAP Details",

    EAP_ACTION_START_SETUP_DRAFT: "Start Set-Up Draft",
    EAP_ACTION_VIEW_CURRENT_SETUP_DRAFT: "View Current Set-Up Draft",
    EAP_ACTION_EDIT_MAIN_DETAILS: "Edit Main Details",
    EAP_ACTION_EDIT_REASON_SPECIFIC_USAGE: "Edit Reason Specific Usage",
    EAP_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    EAP_ACTION_DUPLICATE_SETUP: "Duplicate Set-Up",
    EAP_ACTION_DISABLE_SETUP: "Disable Set-Up",
    EAP_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    EAP_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    EAP_ACTION_DISCARD_DRAFT: "Discard Draft",

    EAP_DETAILS: "EAP Set-Up #{providerId}",
    EAP_DETAILS_DRAFT: "Draft for EAP Set-Up #{providerId}",
    EAP_DETAILS_LAST_UPDATED_BY: "Last edited by:",
    EAP_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    EAP_DETAILS_LIVE_DATA_BANNER: "Following Below Is Live Data Associated with This Set-Up!",
    EAP_DETAILS_LIVE_DATA_BANNER_ADDITIONAL:
      "Note: Editing this data is outside the draft-review process and updates will take effect immediately.",
    EAP_DETAILS_MAIN_DETAILS: "Main Details",
    EAP_DETAILS_REASON_SPECIFIC_USAGE: "Reason Specific Usage",
    EAP_DETAILS_HIERARCHY_SCOPE: "Hierarchy Scope",
    EAP_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    EAP_DETAILS_PROVIDER_NUMBER: "EAP Number",
    DETAILS_PROVIDER_NUMBER: "Number",
    EAP_DETAILS_PROVIDER_STATUS: "Status",
    EAP_DETAILS_PROVIDER_NAME: "Provider Name",
    EAP_DETAILS_PROVIDER_PHONE_NUMBER: "Phone  Number",
    EAP_DETAILS_PROVIDER_USAGE_INSTRUCTIONS: "Usage Instructions",

    EAP_EDIT_CURRENT_DRAFT: "Edit Current Draft",
    EAP_SUBMIT_CHANGES: "Submit Changes",
    EAP_CANCEL_REVIEW: "Cancel Review",

    ADD_WELLBEING_SERVICE_TITLE: "Add Wellbeing Service",
    ADD_WELLBEING_SERVICE_MODAL_STEP_1_TITLE: "1/2 Provider Details",
    ADD_WELLBEING_SERVICE_MODAL_STEP_1_NEXT_BUTTON: "Next Hierarchy Scope",
    ADD_WELLBEING_SERVICE_MODAL_STEP_2_TITLE: "2/2 Hierarchy Scope",
    ADD_WELLBEING_SERVICE_MODAL_STEP_1_NEXT_BUTTON: "Next Hierarchy Scope",
    ADD_WELLBEING_SERVICE_MODAL_STEP_2_TITLE: "2/2 Hierarchy Scope",
    EDIT_EAP_MODAL_TITLE: "Draft for Set-up #{providerId}",
    EDIT_EAP_MODAL_TITLE_FC: "Set-up #{providerId}",
    EDIT_EAP_MODAL_STEP_1_TITLE: "1/2 Provider Details",
    EDIT_EAP_MODAL_STEP_1_NEXT_BUTTON: "Next Reason Specific Usage",
    EDIT_EAP_MODAL_STEP_2_TITLE: "2/2 Next Hierarchy Scope",
    EDIT_EAP_MODAL_STEP_2_NEXT_BUTTON: "Next Hierarchy Scope",
    EAP_PROVIDER_NAME: "EAP Provider Name",
    EAP_NUMBER: "EAP Number",

    EAP_DETAILS_ABSENCE_REASON: "Absence Reason",
    EAP_DETAILS_CALL_FLOW_DISPLAY: "Call Flow Display",
    EAP_DETAILS_EMPLOYEE_TEXT: "Employee Text",
    EAP_DETAILS_SELECTED_AREAS: "Selected Areas",
    EAP_DETAILS_AREAS_RESTORED: "Areas Restored",
    EAP_DETAILS_SAVE: "Save",
    EAP_DETAILS_SUBMIT_FOR_REVIEW: "Submit for Review",

    // Approvable Title
    APPROVABLE_TITLE: "{type} #{id}",
    APPROVABLE_TITLE_DUPLICATE: "Duplicate",
    APPROVABLE_TITLE_DISABLE: "Disable",
    APPROVABLE_TITLE_ENABLE: "Enable",

    APPROVABLE_LOCKED_DEPENDENCIES:
      "This section is locked and cannot be edited due to a dependency.",
    APPROVABLE_DRAFT_IS_AWAITING_REVIEW: "This draft is awaiting review",
    APPROVABLE_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",

    // TODO - check approvable strings and remove
    // Approvable Changeset Modals
    APPROVABLE_SUBMIT_DESCRIPTION: "Notes for submission",

    APPROVABLE_DISABLE_SETUP_TITLE: "Disable {approvableType}",
    APPROVABLE_DISABLE_SETUP_QUESTION:
      "Are you sure you want to disable {approvableType} {approvableName}?",
    APPROVABLE_DISABLE_SETUP_INFO_ACTIVE_ONLY:
      "Please note this will create a draft for this set-up with its status changed to disabled and automatically submitted for review.",
    APPROVABLE_DISABLE_SETUP_SUBMIT_ACTIVE_ONLY: "Disable",
    APPROVABLE_DISABLE_SETUP_INFO_ACTIVE_WITH_DRAFT:
      "Please note that this record has a draft in progress.  Proceeding will change the status of the set-up in the draft, but will not submit it for review",
    APPROVABLE_DISABLE_SETUP_SUBMIT_ACTIVE_WITH_DRAFT: "Disable and Update Draft",
    APPROVABLE_DISABLE_SETUP_INFO_ACTIVE_WITH_DRAFT_PENDING_REVIEW:
      "Please note that this set-up already has a pending review.  Proceeding will update the status of the set-up in the draft and keep it in review.",
    APPROVABLE_DISABLE_SETUP_SUBMIT_ACTIVE_WITH_DRAFT_PENDING_REVIEW: "Disable and Keep in sReview",
    APPROVABLE_DISABLE_SETUP_WARNING:
      "This set-up cannot be disabled as it has an open or awaiting review draft.",
    APPROVABLE_ENABLE_SETUP_TITLE: "Enable {approvableType}",
    APPROVABLE_ENABLE_SETUP_QUESTION:
      "Are you sure you want to enable {approvableType} {approvableName}?",
    APPROVABLE_ENABLE_SETUP_INFO_ACTIVE_ONLY:
      "Please note this will create a draft for this set-up with its status changed to enabled and automatically submitted for review.",
    APPROVABLE_ENABLE_SETUP_SUBMIT_ACTIVE_ONLY: "Enable and Submit for Review",
    APPROVABLE_ENABLE_SETUP_INFO_ACTIVE_WITH_DRAFT:
      "Please note that this record has a draft in progress.  Proceeding will change the status of the set-up in the draft, but will not submit it for review",
    APPROVABLE_ENABLE_SETUP_SUBMIT_ACTIVE_WITH_DRAFT: "Enable and Update Draft",
    APPROVABLE_ENABLE_SETUP_INFO_ACTIVE_WITH_DRAFT_PENDING_REVIEW:
      "Please note that this set-up already has a pending review.  Proceeding will update the status of the set-up in the draft and keep it in review.",
    APPROVABLE_ENABLE_SETUP_SUBMIT_ACTIVE_WITH_DRAFT_PENDING_REVIEW: "Enable and Keep in Review",
    APPROVABLE_ENABLE_SETUP_WARNING:
      "This set-up cannot be enabled as it has an open or awaiting review draft.",

    // Hierarchy Scope
    HIERARCHY_SCOPE_FIND_DEPARTMENTS: "Find department...",
    HIERARCHY_SCOPE_AREAS_INCLUDED: "Areas Included",
    HIERARCHY_SCOPE_AREAS_EXCLUDED: "Areas Excluded",
    HIERARCHY_SCOPE_UNIT_NAME: "Unit Name",
    HIERARCHY_SCOPE_START_DATE: "Start Date",
    HIERARCHY_SCOPE_START_DATE_TOOLTIP:
      "Use this field to insert a date using a DD/MM/YYYY format. This date dictates the point in time at which your standard question will apply to your chosen hierarchy area(s).",
    HIERARCHY_SCOPE_END_DATE: "End Date",
    HIERARCHY_SCOPE_END_DATE_TOOLTIP:
      "If it is known, use this field to determine the point in time at which your chosen question ceases to be practically applied.",
    HIERARCHY_SCOPE_EXCLUDED_DATE: "Date Excluded",
    HIERARCHY_SCOPE_RESTORED_DATE: "Restore Date",

    // Absence Reasons
    ABSENCE_REASONS_LIVE: "Live Absence Reasons",
    ABSENCE_REASONS_LIVE_FC: "Live Absence Reasons FC",
    ABSENCE_REASONS_LIVE_EMPTY: "No Live Absence Reasons to review",
    ABSENCE_REASONS_PENDING_REVIEW: "Absence Reasons Pending Review",
    ABSENCE_REASONS_PENDING_REVIEW_FC: "Absence Reasons Pending Review FC",
    ABSENCE_REASONS_PENDING_REVIEW_EMPTY: "No Pending Absence Reasons to review",
    ABSENCE_REASONS_PENDING_REVIEW_EMPTY_FC: "No Pending Absence Reasons to review",
    ABSENCE_REASONS_DRAFT_FC: "Absence Reasons Drafts FC",
    ABSENCE_REASONS_DRAFT: "Absence Reasons Drafts",
    ABSENCE_REASONS_DRAFT_EMPTY: "No Draft Absence Reasons to review",
    ABSENCE_REASONS_DRAFT_EMPTY_FC: "No Draft Absence Reasons to review",
    ABSENCE_REASON_ACTION_START_DRAFT: "Start Absence Reason Draft",
    ABSENCE_REASON_ACTION_VIEW_CURRENT_DRAFT: "View Current Absence Reason Draft",
    ABSENCE_REASON_ACTION_EDIT_MAIN_DETAILS: "Edit Main Details",
    ABSENCE_REASON_ACTION_DUPLICATE_SETUP: "Duplicate Absence Reason",
    ABSENCE_REASON_ACTION_DISABLE_SETUP: "Disable Absence Reason",
    ABSENCE_REASON_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    ABSENCE_REASON_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    ABSENCE_REASON_ACTION_EDIT_REASON_SPECIFIC_USAGE: "Edit Reason Specific Usage",
    ABSENCE_REASON_ACTION_DISCARD_DRAFT: "Discard Draft",
    ABSENCE_REASON_ACTION_EDIT_LENGTH_SCOPE: "Edit Length Scope",
    ABSENCE_REASON_ACTION_EDIT_ANSWER_OPTIONS: "Edit Answer Options",
    ABSENCE_REASON_ACTION_EDIT_QUESTION_TYPE: "Edit Question Type",
    ABSENCE_REASON_DETAILS: "Absence Reason #{id}",
    ABSENCE_REASON_DRAFT: "Draft for Absence Reason #{id}",
    ABSENCE_REASON_LAST_UPDATED_BY: "Last edited by:",
    ABSENCE_REASON_DETAILS_QUESTION_TYPE: "Question Type",
    ABSENCE_REASON_DETAILS_REASON_SCOPE: "Reason Scope",
    ABSENCE_REASON_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    ABSENCE_REASON_DETAILS_LENGTH_SCOPE: "Length Scope",
    NO_ANSWER_OPTIONS_ADDED: "No Answer Options Added",
    ABSENCE_REASON_DETAILS_ANSWER_OPTIONS: "Answer Options",
    ESSENTIALS_SERVICE_TYPE_MESSAGE:
      "This feature is a part of GoodShapeHealth which is not enabled for your organisation. To upgrade your account, please contact your client success manager.",
    EDIT_ABSENCE_REASON_MODAL_TITLE: "Edit Absence Reason #{providerId}",
    EDIT_ABSENCE_REASON_MODAL_TITLE_FC: "Absence Reason #{providerId}",
    APPROVABLE_TYPE_ABSENCE: "Absence Reason",
    ABSENCE_REASONS_ID: "Id",
    ABSENCE_REASONS_ABSENCE_REASON: "Absence Reason",
    ABSENCE_REASONS_PARENT_REASON: "Parent Reason",
    ABSENCE_REASONS_NURSE_ELIGIBILITY: "Nurse Eligibility",
    ABSENCE_REASONS_NURSE_TRANSFER_ELIGIBILITY_ABSENCE_DURATION: "Nurse Min Duration",
    ABSENCE_REASONS_DISPLAY_NAME: "Display Name",
    ABSENCE_REASONS_TYPE: "Type",
    ABSENCE_REASONS_DATE_ADDED: "Date Added",
    ADD_ABSENCE_REASON_MODAL_TITLE: "New Absence Reason",
    EDIT_ABSENCE_REASON_SUBMIT_BUTTON: "Save Absence Reason",
    ABSENCE_REASON_NAME: "Name",
    ABSENCE_REASON_DETAILS_MAIN_DETAILS: "Main Details",
    ABSENCE_REASON_DETAILS_LOCKED_PENDING_REVIEW: "Absence Reason Pending Review",
    MEDICAL: "Medical",
    NON_MEDICAL: "Non-Medical",
    GOOD_SHAPE_CLASSIFICATION: "GoodShape Classification",

    // ALERTS
    ALERTS: "Alerts",
    MESSAGES: "Messages",
    CANCEL_ALERT_CONFIRMATION_TEXT:
      "Are you sure you want to cancel this alert? This action is irreversible, and the alert will no longer be linked to this absence record or included in any reports.",
    YES_CANCEL_ALERT: "Yes, cancel alert",
    NO_KEEP_ALERT: "No, keep alert",
    ADOPTION: "Adoption",
    LOWEST: "Lowest",
    HIGHEST: "Highest",
    INSTRUCTIONS: "Instructions",
    DOWNLOADS_IN_LAST_DAYS: "Downloads in Last 14 Days",
    PERCENTAGE_OF_EMPLOYEES_ONBOARDED: "% of Employees Onboarded",
    ACTIVE_EMPLOYEES: "Active Employees",
    ADOPTION_RATE: "Adoption Rate %",
    ALERTS_LOCKED_DEPENDENCIES: "This section is locked and cannot be edited due to a dependency.",
    ALERTS_CREATE_NEW: "Create New Alert",
    ALERTS_VIEW_RECENTLY_TRIGGERED_ALERTS: "View Recently Triggered Alerts",
    ALERTS_LIVE_REASONS: "Live Alerts",
    ALERTS_LIVE_REASONS_FC: "Live Alerts",
    ALERTS_LIVE_REASONS_EMPTY: "No live alerts to review",
    ALERTS_LIVE_REASONS_EMPTY_FC: "No live alerts to review",
    ALERTS_PENDING_REVIEW: "Alerts Pending Review",
    ALERTS_PENDING_REVIEW_FC: "Alerts Pending Review",
    ALERTS_PENDING_REVIEW_EMPTY: "No draft alerts pending review",
    ALERTS_PENDING_REVIEW_EMPTY_FC: "No drafts alerts awaiting review",
    ALERTS_DRAFT: "Draft Alerts",
    ALERTS_DRAFT_FC: "Client Draft Alerts",
    ALERTS_DRAFT_EMPTY: "No draft alerts to view",
    ALERTS_DRAFT_EMPTY_FC: "No client draft alerts to view",
    ALERTS_ALERT_ID: "Alert ID",
    ALERTS_ALERT_TYPE: "Alert Type",
    ALERTS_ALERT_NAME: "Alert Name",
    ALERTS_ALERT_ABSENCE_TYPE: "Absence Type",
    ALERTS_ALERT_ABSENCE_TYPES_COVERED: "Absence Types Covered",
    ALERTS_ALERT_VALID_FROM: "Valid From",
    ALERTS_ALERT_END_DATE: "End Date",
    ALERTS_ALERT_TRIGGER_POINT: "Trigger Point",
    ALERTS_ALERT_PURPOSE: "Alert Purpose",
    ALERTS_ALERT_FTE_PRO_RATA_ADJUSTMENT: "FTE Pro-Rata Adjustment",

    ALERT_DETAILS_ID: "Alert #{alertId}",
    ALERT_DETAILS_DRAFT: "Draft for Alert #{alertId}",
    ALERT_DETAILS_LAST_UPDATED_BY: "Last edited by:",
    ALERT_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    ALERT_EDIT_CURRENT_DRAFT: "Edit Current Draft",
    ALERT_SUBMIT_CHANGES: "Submit Changes",
    ALERT_CANCEL_REVIEW: "Cancel Review",
    ALERT_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    ALERT_DETAILS_CRITERIA: "Criteria",
    ALERT_DETAILS_CRITERIA_ALERT_DETAILS: "Alert Details",
    ALERT_DETAILS_CRITERIA_REASONS_FOR_EXCLUSIONS: "Reasons for Excluding an Employee",
    ALERT_DETAILS_EMPLOYEE_EXCLUSION_REASON: "Reason",
    ALERT_DETAILS_EMPLOYEE_EXCLUSION_STATUS: "Status",
    ALERT_DETAILS_ADD_EXCLUSION_REASON: "Add Reason for Exclusion",
    ALERT_DETAILS_CONTENT_ENTER_NOTES: "Enter your notes here",
    FIELDS: "Fields",
    DEFAULT: "Default",
    ATTACHMENTS: "Attachments",
    NO_ATTACHMENTS_MESSAGE: "No attachments have been added to this alert",
    ALERT_DETAILS_CONTENT_EMAIL_ATTACHMENTS: "Email Attachments",
    ALERT_DETAILS_CONTENT_UPLOAD_EMAIL:
      "Upload email attachments for this alert from the alert details page.",

    ALERT_DETAILS_BESPOKE_RECIPIENTS: "Bespoke",
    NO_BESPOKE_RECIPIENTS_MESSAGE: "No bespoke recipients have been added to this alert.",
    NO_STAFF_GROUP_RESTIRCTIONS_MESSAGE: "No staff group restrictions apply to this alert.",
    ALERT_DETAILS_BESPOKE_RECIPIENTS_SETUP:
      "Setup bespoke recipients for this alert on the alert details page.",
    ALERT_DETAILS_ADD_BESPOKE_RECIPIENT: "Add Bespoke Recipient",
    ALERT_DETAILS_BESPOKE_RECIPIENTS_EMPLOYEE_REF: "Employee Ref",
    ALERT_DETAILS_BESPOKE_RECIPIENTS_EMPLOYEE_NAME: "Employee Name",
    ALERT_DETAILS_BESPOKE_RECIPIENTS_DEPARTMENT: "Department",
    ALERT_DETAILS_ADD_EMAIL_ATTACHMENT: "Add Attachment",
    ALERT_DETAILS_EMAIL_ATTACHMENT_ID: "Attachment Id",
    ALERT_DETAILS_EMAIL_ATTACHMENT_NAME: "File Name",
    ALERT_DETAILS_BESPOKE_WORK_EMAIL_ADDRESS: "Work Email Address",

    ALERT_DETAILS_REASON_SCOPE: "Reason Scope",
    ALERT_DETAILS_REASON_SCOPE_ALL: "All",
    ALERT_DETAILS_REASON_SCOPE_SPECIFIC_REASON: "Specific Reason",
    ALERT_DETAILS_ADD_ABSENCE_REASON: "Add Absence Reason",

    ALERT_DETAILS_STAFF_GROUPS: "Staff Groups",
    ALERT_DETAILS_ADD_STAFF_GROUP: "Add Staff Group",

    ALERT_DETAILS_SERVICE_LENGTH: "Service Length",
    ALERT_DETAILS_SERVICE_LENGTH_RESTRICT: "Restrict to Employees Who Have Worked",
    ALERT_DETAILS_SERVICE_LENGTH_RESTRICT_LESS_THAN:
      "Restrict to Employees Who Have Worked Less Than",
    ALERT_DETAILS_SERVICE_LENGTH_RESTRICT_MORE_THAN:
      "Restrict to Employees Who Have Worked More Than",
    ALERT_DETAILS_SERVICE_LENGTH_UNRESTRICTED: "Not Restricted",

    ALERT_DETAILS_LIVE_DATA_BANNER: "Following Below Is Live Data Associated with This Set-Up!",
    ALERT_DETAILS_LIVE_DATA_BANNER_ADDITIONAL:
      "Note: Editing this data is outside the draft-review process and updates will take effect immediately.",

    ALERT_ADD_TITLE: "New Alert",
    ALERT_EDIT_TITLE: "Edit Alert #{alertId}",
    ALERT_EDIT_HIERARCHY_SCOPE: "Alert #{alertId} Hierarchy Scope",
    ALERT_STEP0: "Alert Type",
    ALERT_STEP1: "Criteria",
    ALERT_STEP1_NEXT_BUTTON: "Next: Content",
    ALERT_STEP2: "Content",
    ALERT_STEP2_NEXT_BUTTON: "Next: Absence Reasons",
    ALERT_STEP3: "Absence Reasons",
    ALERT_STEP4: "Recipients",
    ALERT_STEP4_NEXT_BUTTON: "Next: Restrict to Staff Groups",
    ALERT_STEP5: "Staff Groups",
    ALERT_STEP5_NEXT_BUTTON: "Next: Service Length",
    ALERT_STEP6: "Service Length",
    ALERT_STEP7: "Hierarchy Scope",

    ALERTS_ACTION_START_SETUP_DRAFT: "Start Set-Up Draft",
    ALERTS_ACTION_VIEW_CURRENT_SETUP_DRAFT: "View Current Set-Up Draft",
    ALERTS_ACTION_EDIT_DETAILS: "Edit Details",
    ALERTS_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    ALERTS_ACTION_DUPLICATE_SETUP: "Duplicate Set-Up",
    ALERTS_ACTION_DISABLE_SETUP: "Disable Set-Up",
    ALERTS_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    ALERTS_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    ALERTS_ACTION_DISCARD_DRAFT: "Discard Draft",
    APPROVABLE_TYPE_ALERT: "Alert",
    SETTING: "Setting",
    ALERTS_INSTRUCTIONS: "Alerts Instructions",
    ALERT_CRITERIA: "Alert Criteria",
    ALERT_CONTENT: "Alert Content",
    ALERT_RECIPIENTS: "Alert Recipients",
    ALERT_SCOPE: "Alert Scope",
    DEFAULT_RECIPIENTS: "Default Recipients",
    BESPOKE_RECIPIENTS: "Bespoke Recipients",
    ALERTS_HELP_INTRODUCTION:
      "Alerts are a vital element in the management of absence. They can be configured to trigger a variety of actions and are designed to notify relevant stakeholders with certain events have taken place, and a resulting action is required.",
    ALERTS_HELP_NAME_DESCRIPTION:
      "The alert name is what appears in reports and notifications whenever it is triggered by an employee. When creating an alert, choose a name that includes some details about the criteria that will trigger it.",
    ALERTS_HELP_STATUS_DESCRIPTION: `If an Alert is set to "Inactive", it will not be checked when employee's report or update absences. For the alert to be checked, this setting must be set to "Active".`,
    ALERTS_HELP_ABSENCE_TYPE_DESCRIPTION: `This setting is used to control whether the alert applies to All absence types or just a certain type. For example, if this is set as "Medical Only" the alert will not be checked when an employee reports a Non-medical absence.`,
    ALERTS_HELP_REFERENCE_DESCRIPTION:
      "{title}: This means the alert will be sent to line managers, but no actions will be triggered as a result.",
    ALERTS_HELP_MONITORING_DESCRIPTION:
      "{title}: This means the alert is designed for use in an Absence Monitoring process and will only trigger  if it has been assigned to one or more absence monitoring levels.",
    ALERTS_HELP_WELLBEING_DESCRIPTION:
      "{title}: This means the alert is designed to trigger a referral to a health service provider, and will only trigger if it is assigned to one or more Referral processes.",
    ALERTS_HELP_SETTINGS_CONTROL_OPTIONS_DESCRIPTION:
      "This setting controls when the alert will be sent to the manager. There are 3 options:",
    ALERTS_HELP_SETTINGS_CONTROL_ONCLOSE_DESCRIPTION:
      "{title}: The alert will only be sent when the employee closes their absence, even if the alert criteria was earlier.",
    ALERTS_HELP_SETTINGS_CONTROL_PREDICTED_DESCRIPTION:
      "{title}: The alert is able to be sent early if its criteria is expected to be met in the future. For example, an alert set to trigger for absences lasting 20 days or more, could trigger on day one of the absence is the return to work date was set more than 20 days in the future.",
    ALERTS_HELP_SETTINGS_CONTROL_TIME_DESCRIPTION:
      "{title}: The alert will not trigger until the exact point it is met. For example, if an alert was set to trigger for absences lasting 20 days or more, it will only trigger once the 20th day has been reached.",
    ALERTS_HELP_VALID_FROM_DESCRIPTION:
      "The alert will only start being checked against absences from this date onwards.",
    ALERTS_HELP_END_DATE_DESCRIPTION:
      "The alert will stop being checked against absences from this date onwards.",
    ALERTS_HELP_DAYS_DESCRIPTION:
      "This is the total number of absence days an employee must have to trigger the alert. It is used in combination with the Day Type setting for Alert Types that use a Days Lost figure as part of their trigger criteria.",
    ALERTS_HELP_DAY_TYPE_DESCRIPTION:
      "This setting controls whether the alert is based on a certain number of working days or calendar days lost within the chosen period. It is used with the Days setting for Alert Types that use a Days Lost figure as part of their trigger criteria.",
    ALERTS_HELP_FTE_DESCRIPTION:
      "If this is set to Yes, the number of absence days requried to trigger the alert will be impacted by the employees FTE. For example, if the alert is set to trigger after 5 days, an employee with an FTE of 1 will need to have 5 days of absence to trigger it. But an employee with an FTE of 0.5 would only need to report 2.5 days of absence to trigger it.",
    ALERTS_HELP_INSTRUCTION_DESCRIPTION:
      "Use this space to confirm any instructions you expect a line manager to follow when they receive the alert. The instructions will appear at the top of the Alert notification.",
    ALERTS_HELP_FIELDS_DESCRIPTION:
      "Here, you can select which fields of information will appear in the alert email notification that is sent to the designated alert recipients. Only select the fields that are essential.",
    ALERTS_HELP_ATTACHMENTS_DESCRIPTION:
      "If there are important documents, such as policies or leaflets, that you want the alert recipient to see, you can attach these to the alert.",
    ALERTS_HELP_DEFAULT_RECIPIENTS_DESCRIPTION:
      "You can select several pre-set distribution lists that will receive a copy of the alert email.",
    ALERTS_HELP_BESPOKE_RECIPIENTS_DESCRIPTION:
      "You can also add specific individuals as bespoke recipients as well, and choose which area of the hierarchy they receive the alert for.",
    ALERTS_HELP_ABSENCE_REASONS_DESCRIPTION: `Alerts default to including all absence reasons within the "Absence Type" selected above. If you need to restrict this alert to checking specific reasons only, select "Specific Reasons" and add your required classifications.`,
    ALERTS_HELP_STAFF_GROUPS_DESCRIPTION:
      "By default, the alert will not be restricted to a particular group of staff. If you wish to restrict the alert to checking the absences of specific groups of Staff, click the Add button and select your required Staff Groups.",
    ALERTS_HELP_SERVICE_LENGTH_DESCRIPTION:
      "If you do not want to restrict the alert to employees with a specific service length, leave the option unticked. If you do want to restrict the scope of the alert, tick the button and then select your required settings.",

    // Alert Types Enum Values
    ABSENCE_RATE_PERCENTAGE: "Absence rate percentage",
    ABSENCE_REASON_ALERT_TYPE: "Absence reason alert type",
    BRADFORD_SCORE_OVER_X_IN_Y_MONTHS: "Bradford score over x in y months",
    HOURS_LOST_OVER_AVG_WCH_IN_Y_PERIOD_OVER_Z_PERIOD_TYPE:
      "Hours lost over avg wch in y period over z period type",
    WORK_RELATED: "Work related",
    X_DAY_TYPE_IN_Y_PERIOD_TYPE: "X day type in y period type",
    X_DAY_TYPE_OF_CONTINUOUS_ABSENCE: "X day type of continuous absence",
    X_DAY_TYPE_OR_Z_SPELLS_IN_Y_PERIOD_TYPE: "X day type or z spells in y period type",
    X_DAY_TYPE_OVER_Z_SPELLS_IN_Y_PERIOD_TYPE: "X day type over z spells in y period type",
    X_HOURS_IN_Y_PERIOD_TYPE: "X hours in y period type",
    X_SPELLS_IN_Y_PERIOD_TYPE: "X spells in y period type",
    X_SPELLS_OF_LESS_GREATER_THAN_Z_DAY_TYPE_IN_Y_PERIOD_TYPE:
      "X spells of less greater than z day type in y period type",
    X_SPELLS_OF_SAME_REASON_IN_Y_PERIOD_TYPE: "X spells of same reason in y period type",

    // Alert Trigger Mode Enum Values
    ACTUAL_TIME: "Actual Time",
    ON_CLOSE: "On Close",
    PREDICTED: "Predicted",

    // Alert Purpose Enum Values
    MONITORING_PROMPT: "Monitoring Prompt",
    NURSE_CALLBACK: "Nurse Callback",
    REFERENCE_ALERT: "Reference Alert",
    WELLBEING_REFERRAL: "Wellbeing Referral",
    ALERTS_PURPOSE_WARNING_TOOLTIP: "This alert is not being used in any {title} process",

    // Alert MoreOrLessThan Enum Values
    LESS_THAN: "Less Than",
    MORE_THAN: "More Than",

    // Referrals
    REFERRAL_APPROVABLE_TYPE: "Referral",
    REFERRALS: "Referrals",
    REFERRALS_ADMIN: "Referral Interview Admin",
    REFERRALS_PAGE_DESCRIPTION:
      "What is physically asked of an employee during a return to work interview is configured (and subsequently controlled) using this page.",
    REFERRAL_LOCKED_DEPENDENCIES:
      "This section is locked and cannot be edited due to a dependency.",
    REFERRAL_PROCESS: "Referral Process",
    REFERRAL_PROCESS_NAME: "Referral Process Name",

    REFERRAL_DETAILS_PROCESSID: "Referral Process #{processId}",
    REFERRAL_DETAILS_TITLE: "Referral Details",
    REFERRAL_DETAILS_DRAFT: "Draft for Referral Process #{processId}",
    REFERRAL_DETAILS_LAST_UPDATED_BY: "Last edited by:",
    REFERRAL_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    REFERRAL_START_DRAFT: "Start Referral Process",
    REFERRAL_EDIT_CURRENT_DRAFT: "Edit Current Process",
    REFERRAL_SUBMIT_CHANGES: "Submit Changes",
    REFERRAL_CANCEL_REVIEW: "Cancel Review",
    REFERRAL_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    ALERTS_FOR_MANAGER_LED_REFERRALS: "Alerts for Manager Led Referrals",
    AT_LEAST_ONE_ACTIVE_REASON_MUST_BE_PROVIDED: "At least one active reason must be provided",
    AT_LEAST_ONE_ACTIVE_SUPPORT_ACTION_MUST_BE_PROVIDED:
      "At least one active support action must be provided",
    REFERRAL_DETAILS_REFERRAL_MECHANISM: "Referral Mechanism",
    ACTIVE: "Active",
    REASON: "Reason",
    COMPLIANCE_SETTINGS: "Compliance Settings",
    REFERRAL_DETAILS_ALERTS_FOR_EMPLOYEE_LED_REFERRALS: "Alerts for Employee Led Referrals",
    REFERRAL_DETAILS_DECLINING_REFERRALS: "Declining Referrals",
    DECLINED_REFERRAL: "Declined Referral",
    PLEASE_REVIEW_THE_ALERT_LIST:
      "One or more alerts are already in use for Manager Led Referrals. Please review the alert list and update it where needed.",
    TRACKING: "Tracking",
    REQUIRED_RESPONSE: "Required Response",
    TREATMENT: "Treatment",
    TREATMENT_OPTIONS: "Treatment Options",
    ADD_TREATMENT: "Add Treatment",
    REFERRAL_QUESTIONS: "Referral Questions",
    REFERRAL_DETAILS_OUTCOMES: "Outcomes",
    NO_OUTCOME_ERROR: "You should specify a valid 'Outcome'",
    NO_REASON_ERROR: "You should specify a valid 'Reason'",
    REFERRAL_DETAILS_ADD_ATTACHMENT: "Add Attachment",
    REFERRAL_DETAILS_ADD_ATTACHMENTS_INFO:
      "Upload notification attachments for this Referral process from the Referral details page.",
    REFERRAL_DETAILS_HIERARCHY_SCOPE: "Hierarchy Scope",
    REFERRAL_DETAILS_LIVE_DATA_BANNER: "Following Below Is Live Data Associated with This Set-Up!",
    REFERRAL_DETAILS_LIVE_DATA_BANNER_ADDITIONAL:
      "Note: Editing this data is outside the draft-review process and updates will take effect immediately.",

    REFERRAL_ADD_TITLE: "New Referral Process",
    REFERRAL_EDIT_TITLE: "Edit Referral Process #{processId}",
    REFERRAL_EDIT_HIERARCHY_SCOPE_TITLE: "Referral Process #{processId} Hierarchy Scope",
    SUPPLIER_DETAILS: "Supplier Details",
    NEXT_MANAGER_LED_REFERRALS: "Next: Manager Led Referrals",
    MANAGER_LED_REFERRALS: "Manager Led Referrals",
    NEXT_EMPLOYEE_LED_REFERRALS: "Next: Employee Led Referrals",
    EMPLOYEE_LED_REFERRALS: "Employee Led Referrals",
    NEXT_SUPPLIER_TRACKING: "Next: Supplier Tracking",
    SUPPLIER_TRACKING: "Supplier Tracking",
    NEXT_MANUAL_REFERRALS: "Next: Manual Referrals",
    MANUAL_REFERRALS: "Manual Referrals",
    MANUAL_REFERRALS_INFO:
      "By default, only Client Admin users have the permission to manually refer an employee to your chosen Service Provider. If you would like to grant Manager, Advanced User and Full Access users the permission to manually refer employees, please visit the {securityLink} page.",
    NEXT_HIERARCHY_SCOPE: "Next: Hierarchy Scope",
    REFERRAL_STEP6: "Hierarchy Scope",
    EMPLOYEE_REFERRAL_NO_ALERT_CONFIGURATION:
      "For a successful Referrals process configuration, please ensure that the alerts are set up with the correct 'Alert Purpose - Wellbeing Referral' before creating a new process.",
    ABSENCE_MONITORING_NO_ALERT_CONFIGURATION:
      "For a successful Absence Monitoring process configuration, please ensure that the alerts are set up with the correct 'Alert Purpose - Monitoring Prompt' before creating a new process.",

    REFERRAL_ACTION_START_SETUP_DRAFT: "Start Process Draft",
    REFERRAL_ACTION_VIEW_CURRENT_SETUP_DRAFT: "View Current Process Draft",
    REFERRAL_ACTION_EDIT_DETAILS: "Edit Details",
    REFERRAL_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    REFERRAL_ACTION_DUPLICATE_SETUP: "Duplicate Process",
    REFERRAL_ACTION_DISABLE_SETUP: "Disable Process",
    REFERRAL_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    REFERRAL_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    REFERRAL_ACTION_DISCARD_DRAFT: "Discard Draft",
    REFERRAL_DETAILS_REASONS_FOR_REFERRAL: "Reasons for Referral",
    REFERRAL_DETAILS_SUPPLIER_TRACKING_ENABLED: "Supplier Tracking Enabled",
    REFERRAL_DETAILS_SUPPLIER_TRACKING_DECLINE_ESCALATION: "Decline Escalation",

    // Referral promotions
    REFERRAL_PROMOTION_HEALTH: "Managed referrals into Occupational Health.",
    REFERRAL_PROMOTION_COMPATIBILITY: "Compatible with in-house and external OH teams.",
    REFERRAL_PROMOTION_FORMS: "Customised referral forms",
    REFERRAL_PROMOTION_LINE_GUIDANCE: "Line Manager guidance and action tracking.",
    REFERRAL_PROMOTION_REPORTS: "Reports on new, active and closed referrals.",
    REFERRAL_PROMOTION_HISTORY: "Referral History reports within Employee Records.",
    REFERRAL_PROMOTION_MORE: "And more!",

    REFERRAL_PROMOTION_OCCUPATIONAL_HEALTH: "Faster Occupational Health referrals.",
    REFERRAL_PROMOTION_WAITING_TIMES: "Reduced waiting times and lost referrals.",
    REFERRAL_PROMOTION_TRANSPARENCY: "Greater transparency.",
    REFERRAL_PROMOTION_INTERVENTION: "Earlier intervention in complex absences.",
    REFERRAL_PROMOTION_ALT_TEXT: "Referral promotions",

    // Return to Work (RTW)
    RETURN_TO_WORK_APPROVABLE_TYPE: "RTW",
    RETURN_TO_WORK_INTERVIEWS: "Return to Work Interviews",
    RETURN_TO_WORK_INTERVIEWS_ADMIN: "RTW Interview Admin",
    RETURN_TO_WORK_INTERVIEWS_PAGE_DESCRIPTION:
      "What is physically asked of an employee during a return to work interview is configured (and subsequently controlled) using this page.",
    RETURN_TO_WORK_LOCKED_DEPENDENCIES:
      "This section is locked and cannot be edited due to a dependency.",
    RETURN_TO_WORK_LIVE_REASONS: "Live Processes",
    RETURN_TO_WORK_LIVE_REASONS_FC: "Live Processes",
    RETURN_TO_WORK_LIVE_REASONS_EMPTY: "No live processes to review",
    RETURN_TO_WORK_LIVE_REASONS_EMPTY_FC: "No live processes to review",
    RETURN_TO_WORK_PENDING_REVIEW: "Processes Pending Review",
    RETURN_TO_WORK_PENDING_REVIEW_FC: "Processes Pending Review",
    RETURN_TO_WORK_PENDING_REVIEW_EMPTY: "No draft processes pending review",
    RETURN_TO_WORK_PENDING_REVIEW_EMPTY_FC: "No drafts processes awaiting review",
    RETURN_TO_WORK_DRAFT: "Draft Processes",
    RETURN_TO_WORK_DRAFT_FC: "Client Draft Processes",
    RETURN_TO_WORK_DRAFT_EMPTY: "No draft processes to view",
    RETURN_TO_WORK_DRAFT_EMPTY_FC: "No client draft processes to view",
    RETURN_TO_WORK_PROCESS: "RTW Process",
    RETURN_TO_WORK_PROCESS_ID: "RTW ID",
    RETURN_TO_WORK_PROCESS_NAME: "RTW Process Name",
    RETURN_TO_WORK_LENGTH_SCOPE: "Length Scope (Working Days)",

    RETURN_TO_WORK_DETAILS: "RTW Process #{processId}",
    RETURN_TO_WORK_DETAILS_DRAFT: "Draft for RTW Process #{processId}",
    RETURN_TO_WORK_DETAILS_LAST_UPDATED_BY: "Last edited by:",
    RETURN_TO_WORK_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    RETURN_TO_WORK_START_DRAFT: "Start RTW Process",
    RETURN_TO_WORK_EDIT_CURRENT_DRAFT: "Edit Current Process",
    RETURN_TO_WORK_SUBMIT_CHANGES: "Submit Changes",
    RETURN_TO_WORK_CANCEL_REVIEW: "Cancel Review",
    RETURN_TO_WORK_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    RETURN_TO_WORK_DETAILS_SETTINGS: "Settings",
    RETURN_TO_WORK_DETAILS_REASON_SCOPE: "Reason Scope",
    RETURN_TO_WORK_DETAILS_COMPLIANCE: "Compliance",
    RETURN_TO_WORK_DETAILS_COMPLIANCE_KPIS_ADD_NEW: "Add New",
    RETURN_TO_WORK_DETAILS_REASONS_LATE_SUBMISSION: "Reasons for Late Submission",
    RETURN_TO_WORK_DETAILS_FORM: "Form",
    RETURN_TO_WORK_DETAILS_ADD_QUESTION: "Add Question",
    RETURN_TO_WORK_DETAILS_NOTIFICATIONS: "Notifications",
    RETURN_TO_WORK_DETAILS_NOTIFICATION_ATTACHMENTS: "Notification Attachments",
    RETURN_TO_WORK_DETAILS_ADD_ATTACHMENT: "Add Attachment",
    RETURN_TO_WORK_DETAILS_ADD_ATTACHMENTS_INFO:
      "Upload notification attachments for this RTW process from the RTW details page.",
    RETURN_TO_WORK_DETAILS_HIERARCHY_SCOPE: "Hierarchy Scope",
    RETURN_TO_WORK_DETAILS_LIVE_DATA_BANNER:
      "Following Below Is Live Data Associated with This Set-Up!",
    RETURN_TO_WORK_DETAILS_LIVE_DATA_BANNER_ADDITIONAL:
      "Note: Editing this data is outside the draft-review process and updates will take effect immediately.",

    RETURN_TO_WORK_ADD_TITLE: "New RTW Process",
    RETURN_TO_WORK_EDIT_TITLE: "Edit RTW Process #{processId}",
    RETURN_TO_WORK_EDIT_HIERARCHY_SCOPE_TITLE: "RTW Process #{processId} Hierarchy Scope",
    RETURN_TO_WORK_STEP1: "Settings",
    RETURN_TO_WORK_STEP1_NEXT_BUTTON: "Next: Compliance",
    RETURN_TO_WORK_STEP2: "Compliance",
    RETURN_TO_WORK_STEP2_NEXT_BUTTON: "Next: Form",
    RETURN_TO_WORK_STEP3: "Form",
    RETURN_TO_WORK_STEP3_NEXT_BUTTON: "Next: Notifications",
    RETURN_TO_WORK_STEP4: "Notifications",
    RETURN_TO_WORK_STEP4_NEXT_BUTTON: "Next: Hierarchy Scope",
    RETURN_TO_WORK_STEP5: "Hierarchy Scope",

    RETURN_TO_WORK_ACTION_START_SETUP_DRAFT: "Start Process Draft",
    RETURN_TO_WORK_ACTION_VIEW_CURRENT_SETUP_DRAFT: "View Current Process Draft",
    RETURN_TO_WORK_ACTION_EDIT_DETAILS: "Edit Details",
    RETURN_TO_WORK_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    RETURN_TO_WORK_ACTION_DUPLICATE_SETUP: "Duplicate Process",
    RETURN_TO_WORK_ACTION_DISABLE_SETUP: "Disable Process",
    RETURN_TO_WORK_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    RETURN_TO_WORK_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    RETURN_TO_WORK_ACTION_DISCARD_DRAFT: "Discard Draft",
    RETURN_TO_WORK_PROCESS_ID_VIEW: "RTW Process ID",
    RETURN_TO_WORK_CREATION_RULE: "Creation Rule",
    RETURN_TO_WORK_ABSENCE_TYPE_SCOPE: "Absence Type Scope",
    RETURN_TO_WORK_ELIGIBILITY_RULE: "Eligibility Rule",
    RETURN_TO_WORK_MANAGER_CAN_CHANGE_REASON: "Manager Can Change Reason",
    RETURN_TO_WORK_REASON_SCOPE: "Reason Scope",
    CAN_CHANGE: "Can Change",
    CANNOT_CHANGE: "Cannot Change",
    ATTACH: "Attach",
    DO_NOT_ATTACH: "Do Not Attach",
    RETURN_TO_WORK_MANAGER_INSTRUCTIONS: "Manager Instructions",
    RETURN_TO_WORK_OVERDUE_RTW_INSTRUCTIONS: "Overdue RTW Instructions",
    RETURN_TO_WORK_ATTACH_ABSENCE_REPORT: "Attach Absence Report",
    CAPTURE_LATE_REAS: "Capture Late Reason",
    DO_NOT_CAPTURE: "Do Not Capture",
    EXPIRY_PERIOD: "Expiry Period",
    REMINDER_TIME: "Reminder Time",
    COPY_IN_MANAGERS_MANAGER: "Copy in Manager`s Manager",
    LATE_REASON_CAPTURE: "Late Reason Capture",
    REMINDER_TYPE: "Reminder Type",
    ONE_OFF: "One off",
    REPEATING: "Repeating",

    // Absence Monitoring
    ABSENCE_MONITORING_APPROVABLE_TYPE: "Absence Monitoring",
    ABSENCE_MONITORING_LOCKED_DEPENDENCIES:
      "This section is locked and cannot be edited due to a dependency.",
    ABSENCE_MONITORING_LIVE_REASONS: "Live Processes",
    ABSENCE_MONITORING_LIVE_REASONS_EMPTY: "No live processes to review",
    ABSENCE_MONITORING_LIVE_REASONS_EMPTY_FC: "No live processes to review",
    ABSENCE_MONITORING_PENDING_REVIEW: "Processes Pending Review",
    ABSENCE_MONITORING_PENDING_REVIEW_FC: "Processes Pending Review",
    ABSENCE_MONITORING_PENDING_REVIEW_EMPTY: "No draft processes pending review",
    ABSENCE_MONITORING_PENDING_REVIEW_EMPTY_FC: "No drafts processes awaiting review",
    ABSENCE_MONITORING_DRAFT: "Draft Processes",
    ABSENCE_MONITORING_DRAFT_FC: "Client Draft Processes",
    ABSENCE_MONITORING_DRAFT_EMPTY: "No draft processes to view",
    ABSENCE_MONITORING_DRAFT_EMPTY_FC: "No client draft processes to view",
    ABSENCE_MONITORING_PROCESS: "Absence Monitoring Process",
    ABSENCE_MONITORING_PROCESS_ID: "ID",
    ABSENCE_MONITORING_PROCESS_NAME: "Process Name",

    ABSENCE_MONITORING_PROCESS_ID_TITLE: "Process ID",
    ABSENCE_MONITORING_PROCESS_NAME_TITLE: "Absence Monitoring Name",
    ABSENCE_MONITORING_PROCESS_TYPE: "Absence Monitoring Type",
    BASIC: "Basic",

    ABSENCE_MONITORING_DETAILS_TITLE: "Absence Monitoring Process #{processId}",
    ABSENCE_MONITORING_DETAILS_DRAFT_TITLE: "Draft for Absence Monitoring Process #{processId}",
    ABSENCE_MONITORING_DETAILS_LAST_UPDATED_BY: "Last edited by:",
    ABSENCE_MONITORING_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    ABSENCE_MONITORING_START_DRAFT: "Start Absence Monitoring Process",
    ABSENCE_MONITORING_EDIT_CURRENT_DRAFT: "Edit Current Process",
    ABSENCE_MONITORING_SUBMIT_CHANGES: "Submit Changes",
    ABSENCE_MONITORING_CANCEL_REVIEW: "Cancel Review",
    ABSENCE_MONITORING_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    ABSENCE_MONITORING_DETAILS_SETTINGS: "Settings",
    ABSENCE_MONITORING_DETAILS_MONITORING_LEVELS: "Levels",
    ACTION_LISTS: "Lists",
    ABSENCE_MONITORING_DETAILS_TASKS: "Tasks",
    ABSENCE_MONITORING_DETAILS_HIERARCHY_SCOPE: "Hierarchy Scope",
    ABSENCE_MONITORING_DETAILS_LIVE_DATA_BANNER:
      "Following Below Is Live Data Associated with This Set-Up!",
    ABSENCE_MONITORING_DETAILS_LIVE_DATA_BANNER_ADDITIONAL:
      "Note: Editing this data is outside the draft-review process and updates will take effect immediately.",
    ABSENCE_MONITORING_DETAILS_COMPLIANCE_SETTINGS: "Compliance Settings",
    ABSENCE_MONITORING_DETAILS_REASONS_FOR_NO_ACTION: "Reasons for Taking No Action",
    ABSENCE_MONITORING_DETAILS_REASONS_ADDITIONAL_SUPPORT_ACTIONS: "Additional Support Actions",
    ABSENCE_MONITORING_DETAILS_ADD_REASON_FOR_TAKING_NO_ACTION: "Add Reason for Taking No Action",
    ABSENCE_MONITORING_DETAILS_ADD_ADDITIONAL_SUPPORT_ACTION: "Add Additional Support Action",

    ABSENCE_MONITORING_ADD_TITLE: "New Absence Monitoring Process",
    ABSENCE_MONITORING_EDIT_TITLE: "Edit Absence Monitoring Process #{processId}",
    ABSENCE_MONITORING_EDIT_HIERARCHY_SCOPE_TITLE:
      "Edit Absence Monitoring Process #{processId} Hierarchy Scope",
    ABSENCE_MONITORING_STEP1: "Settings",
    ABSENCE_MONITORING_STEP1_NEXT_BUTTON: "Next: Compliance",
    ABSENCE_MONITORING_STEP2_COMPLIANCE: "Compliance",
    ABSENCE_MONITORING_STEP2_NEXT_BUTTON: "Next: Levels",
    ABSENCE_MONITORING_STEP3: "Levels",
    ABSENCE_MONITORING_STEP_LEVELS_NEXT_BUTTON: "Next: Lists",
    ABSENCE_MONITORING_STEP4_NEXT_BUTTON: "Next: Appeals",
    ABSENCE_MONITORING_STEP5: "Hierarchy Scope",

    ABSENCE_MONITORING_ACTION_START_SETUP_DRAFT: "Start Process Draft",
    ABSENCE_MONITORING_ACTION_VIEW_CURRENT_SETUP_DRAFT: "View Current Process Draft",
    ABSENCE_MONITORING_ACTION_EDIT_DETAILS: "Edit Details",
    ABSENCE_MONITORING_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    ABSENCE_MONITORING_ACTION_DUPLICATE_SETUP: "Duplicate Process",
    ABSENCE_MONITORING_ACTION_DISABLE_SETUP: "Disable Process",
    ABSENCE_MONITORING_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    ABSENCE_MONITORING_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    ABSENCE_MONITORING_ACTION_DISCARD_DRAFT: "Discard Draft",

    ABSENCE_MONITORING_LEVEL_NO: "Level {no}",
    ABSENCE_MONITORING_LEVEL_EMPLOYESS_NO: "{no} employees",
    ABSENCE_MONITORING_LEVEL_NAME: "Level Name",
    ABSENCE_MONITORING_LEVEL_DESCRIPTION: "Level Description",
    ABSENCE_MONITORING_LEVEL_ALERTS: "Alerts",
    ABSENCE_MONITORING_LEVEL_ALERTS_PLACEHOLDER: "Click to Add Alerts for This Level",
    ABSENCE_MONITORING_LEVEL_LM_MOVEMENTS: "LM Movements",
    ABSENCE_MONITORING_LEVEL_LM_MOVEMENTS_PLACEHOLDER: "Click to Add Levels for Line Manager",
    ABSENCE_MONITORING_LEVEL_HR_MOVEMENTS: "HR Movements",
    ABSENCE_MONITORING_LEVEL_HR_MOVEMENTS_PLACEHOLDER: "Click to Add Levels for HR",
    ABSENCE_MONITORING_LEVEL_TASKS: "Tasks",
    ABSENCE_MONITORING_LEVEL_TASKS_PLACEHOLDER: "Click to Add Tasks for This Level",
    ABSENCE_MONITORING_LEVEL_REVIEW_EXPIRY: "Review & Expiry",
    ABSENCE_MONITORING_LEVEL_REVIEW_PERIOD: "Review Period",
    ABSENCE_MONITORING_LEVEL_AUTO_EXPIRE_AFTER: "Auto Expire After",
    ABSENCE_MONITORING_LEVEL_AUTO_EXPIRE_ACTION: "Auto Expire Action",
    ABSENCE_MONITORING_LEVEL_AUTO_EXPIRE_ACTION_PLACEHOLDER: "-- Select Action --",
    ABSENCE_MONITORING_ADD_LEVEL: "Add Level",

    // Absence Monitoring Promotion
    ABSENCE_MONITORING_PROMOTION_ATTENDANCE:
      "Track employees through your attendance management procedure.",
    ABSENCE_MONITORING_PROMOTION_ALERTS: "Configure alerts for each step of the process.",
    ABSENCE_MONITORING_PROMOTION_MEETINGS: "Track employee warnings and potential dismissals.",
    ABSENCE_MONITORING_PROMOTION_MANAGEMENT:
      "Track employees through your attendance management procedure.",
    ABSENCE_MONITORING_PROMOTION_REPORTS_AND_COMPLIANCE:
      "View reports on manager process compliance.",
    ABSENCE_MONITORING_PROMOTION_EXTRA_REPORTS: "View extra reports within employee records.",

    ABSENCE_MONITORING_PROMOTION_TRANSPARENCY: "Greater transparency over the process.",
    ABSENCE_MONITORING_PROMOTION_COMPLIANCE: "Increased compliance and reduced risk.",
    ABSENCE_MONITORING_PROMOTION_TREATMENT: "Fair and consistent treatment of employees.",
    ABSENCE_MONITORING_PROMOTION_EFFICIENCY: "Increased efficiency and reduced admin.",

    ABSENCE_MONITORING_PROMOTION_ALT_TEXT: "Absence Monitoring Promotions",

    // Special Contacts
    SPECIAL_CONTACTS: "Special Contacts",
    ADD_SPECIAL_CONTACT: "Add Special Contact",
    ADD_SPECIAL_CONTACT_STEP1: "1/3 Special Contact Type",
    ADD_SPECIAL_CONTACT_STEP1_INFO:
      "You can add new custom types in the Custom Special Contact Type section on the parent page.",
    ADD_SPECIAL_CONTACT_STEP2: "2/3 Select Employee",
    ADD_SPECIAL_CONTACT_STEP3: "3/3 Special Hierarchy Scope",
    ALREADY_A_SPECIAL_CONTACT: "Already a Special Contact",
    EDIT_SPECIAL_CONTACT: "Edit Special Contact",
    REMOVE_SPECIAL_CONTACT_MODAL_TITLE: "Remove Special Contact",
    REMOVE_SPECIAL_CONTACT_CONFIRMATION:
      "Are you sure would like to delete {specialContact} special contact?",

    // Special Contact Types
    SPECIAL_CONTACT_TYPE: "Special Contact Type",
    ADD_SPECIAL_CONTACT_TYPE: "Add Special Contact Type",
    RENAME_SPECIAL_CONTACT_TYPE: "Rename Special Contact Type",
    RULES: "Rules",
    REASON_SPECIFIC_MESSAGES: "Reason Specific Messages",
    CUSTOM_ROLES: "Custom Roles",
    CONTACT_TYPES: "Contact Types",
    ADD_NEW_TYPE: "Add New Type",
    REMOVE_SPECIAL_CONTACT_TYPE_MODAL_TITLE: "Remove Special Contact Type",
    REMOVE_SPECIAL_CONTACT_TYPE_CONFIRMATION:
      "Are you sure would like to delete {specialContactType} special contact type?",

    //Reporting Parameters
    INCLUDED: "Included",
    EXCLUDED: "Excluded",
    REPORTING_OPTIONS: "Reporting Options",
    LONG_TERM_DEFINITION_DAYS: "Long Term Absence Definition (Days)",
    LONG_TERM_DEFINITION_TYPE: "Long Term Absence Definition (Day Type)",
    REPORTING_PERIODS: "Reporting Periods",
    ABSENCE_RATE_CALCULATION_TYPE: "Absence Rate Calculation Type",
    BRADFORD_SCORE_ENABLED: "Bradford Score Enabled",
    BRADFORD_SCORE_ABSENCE_TYPE: "Bradford Score Absence Type",
    BRADFORD_SCORE_DAY_TYPE: "Bradford Score Day Type",
    BRADFORD_SCORE_PERIOD_MONTHS: "Bradford Score Period (Months)",
    BV12_TREND_AVAILABLE: "BV12 Trend Available",
    SALARY_COST_ABSENCE_TREND: "Salary Cost of Absence Trend",
    EMPLOYEE_ABSENCE_RATES: "Employee Absence Rates",
    PHASED_RTW_INCLUDED_ABSENCE_RATES: "Phased RTW Included in Absence Rates",
    TREND_ASSUMPTIONS: "Trend Assumptions",
    HISTORICAL_DATA_UNDER_REPORTING: "Historical Data Under-Reporting %",
    DESCRIPTION_DATA_REASON_SUSPECTED_UNDER_REPORTING:
      "Description of Reason for Suspected Under Reporting",
    ESTIMATED_DATA_COST_ABSENCE: "Estimated Daily Cost of Absence",
    DESCRIPTION_REASON_COST_ABSENCE: "Description of Reason for Cost of Absence",
    DESCRIPTION_REASON_SUSPECTED_UNDER_REPORTING: "Description Reason Suspected Under Reporting",
    ESTIMATED_DAILY_COST_ABSENCE: "Estimated Daily Cost of Absence",
    NON_WORKING: "Non-Working",
    WORKING: "Working",
    CALENDAR: "Calendar",
    CALENDAR_MONTH: "Calendar Month",
    "4_4_5_WEEKS": "4, 4, 5 Weeks",
    CALENDAR_DAYS: "Calendar Days",
    FTE_CALENDAR_DAYS: "Fte Calendar Days",
    WORKING_DAYS: "Working Days",
    WORKING_HOURS: "Working Hours",
    WORKING_HOURS_LOST: "Working Hours Lost",
    WORKING_DAYS_LOST: "Working Days Lost",
    WORKING_HOURS_ABSENCE_RATE: "Working hours absence rate",
    HOURS_AVAILABLE: "Hours available",
    CALENDAR_DAYS_LOST: "Calendar Days Lost",
    RTW_COMPLIANCE: "RTW Compliance",
    REASONS_TO_BE_EXCLUDED: "Reasons to Be Excluded",
    BRADFORD_SCORES_EXCLUSIONS: "Bradford Score Exclusions",

    ADD_REASON_TO_BE_EXCLUDED: "Add Reason to be Excluded from BS",
    EDIT_REASON_TO_BE_EXCLUDED: "Edit Reason to be Excluded from BS",
    ABSENCE_REASON_NOT_INCLUDED: "Absence Reason Not Included in Absence Rates",
    DATE_EXCLUDE_FROM: "Date Excluded From",
    DATE_EXCLUDE_TO: "Date Excluded To",
    REPORT_PARAMETERS: "Report Parameters",
    BRADFORD_SCORES: "Bradford Scores",
    EDIT_REPORTING_OPTIONS: "Edit Reporting Options",
    EDIT_TREND_ASSUMPTIONS: "Edit Trend Assumptions",
    SELECT_ABSENCE_REASON: "Select Absence Reason",
    NUMBER_RECORDS_SELECTED: "{number} records selected",
    DELETE_REASON_TO_BE_EXCLUDED_MODAL_TITLE: "Delete Reason",
    DELETE_REASON_TO_BE_EXCLUDED_CONFIRMATION:
      "Are you sure would like to delete {reason} reason to be excluded?",
    DELETE_REASONS_TO_BE_EXCLUDED_CONFIRMATION:
      "Are you sure would like to delete selected reasons to be excluded?",
    TARGET_ABSENCE_RATE: "Target Absence Rate %",
    BV_TREND: "BV12 Trend",
    HISTORIC_DATA_UNDER_REPORTING: "Absence Under-reporting %",
    DAILY_ABSENCE_COST: "Daily Cost of Absence (£)",
    ABSENCE_COST_REASON: "Absence Cost Reason",
    BRADFORD_SCORE_BS: "Bradford Score",
    BS_ABSENCE_TYPE: "Absence Type Scope",
    BS_DAY_TYPE: "Day Type",
    BS_PERIOD_MONTHS: "Period (Months)",
    REPORTS_EXPIRY: "Reports Expiry",
    PERMITTED_USERS: "Permitted Users",
    PERMITTED_USERS_DESCRIPTION: "Control which user types are allowed to schedule reports.",
    AUTO_DISABLE: "Auto Disable",
    ABILITY_TO_SCHEDULE_REPORTS: "Ability to Schedule Reports",
    AUTO_DISABLE_DESCRIPTION:
      "The number of consecutive times the report can run, without the user opening it, before it is disabled.",
    REPORTS_EXPIRY_DESCRIPTION:
      "The number of calendar days that a schedule report is available before expiring if the user does not open it.",
    LONG_TERM_DAYS_DESCRIPTION:
      "Defines the number of days that an absence must last for to be considered long term.",
    LONG_TERM_DAYS_TYPE_DESCRIPTION:
      "Defines the type of day that the long term definition uses. This is either Working Days or Calendar Days.",
    BRADFORD_SCORE_DESCRIPTION:
      "Enables the Bradford Score to appear in employee and absence reports. If disabled, all scores will show as 0.",
    BV12_TREND_DESCRIPTION:
      "Displays BV12 absence rates in trend reports. Commonly used by UK local authorities.",
    TARGET_ABSENCE_DESCRIPTION:
      "Your target rolling absence rate %. Appears for reference on the absence rate trend reports.",
    DATA_UNDER_REPORTING_DESCRIPTION:
      "The estimated % of absences that were not correctly recorded by the client prior to the launch of GoodShape.",
    DAILY_ABSENCE_COST_DESCRIPTION:
      "This is the average cost of a day of absence, that considers costs like replacement staff, overtime and fines.",
    BS_PERIOD_MONTHS_DESCRIPTION:
      "Controls the period (in months) that is used to calculate the Bradford Score.",
    ABSENCE_TYPES_DESCRIPTION:
      "GoodShape can record medical and non-medical absences, or just medical.",
    TIME_PERIOD_TO_REOPEN_DESCRIPTION:
      "Defines how far back in time (using calendar days) an employee is allowed to re-open a closed absence.",
    ALLOW_ABSENCE_REOPEN_DESCRIPTION:
      "Employees will be able to re-open a recently closed absence, instead of starting a new one.",
    RECORD_BANK_HOLIDAYS_DESCRIPTION:
      "Bank holidays can be reported as a day of absence by employees scheduled to work those days.",
    KPI_EXCLUDE_HOLIDAYS_DESCRIPTION:
      "Bank Holidays are not included when calculating the target due date of line manager tasks.",
    KPI_EXCLUDE_WEEKENDS_DESCRIPTION:
      "Weekends are not included when calculating the target due date of line manager tasks.",
    MINIMUM_ABSENCE_DURATION_DESCRIPTION:
      "The minimum length of absence that can be reported to GoodShape.",
    ADVANCE_ABSENCE_CLOSING_DESCRIPTION:
      "The number of hours in advance that employees are allowed to close absences.",
    ABILITY_TO_SCHEDULE_REPORTS_DESCRIPTION:
      "Allows users to schedule reports to automatically run themselves and email the user the results.",
    BS_ABSENCE_TYPE_DESCRIPTION:
      "Control what types of absences are included in the Bradford Score calculation.",
    BS_DAY_TYPE_DESCRIPTION:
      "Control whether the Bradford Score is calculated using working or calendar days.",
    COMPLIANCE_MEASURES: "Compliance Measures",
    NOTICES: "Notices",
    NON_MEDICAL_DESCRIPTION:
      "Message will display to GoodShape Call Agents if the client does not record non-medical absences.",
    SETTINGS_ANNOUNCEMENT_DESCRIPTION:
      "Message will display to GoodShape Call Agents at the top of their screen on every interaction.",

    // Service Summary
    SERVICE_SUMMARY_NOTIFICATION_TEXT_1:
      "Please note that service configuration updates are applied once a day at 10:00pm.",
    SERVICE_SUMMARY_NOTIFICATION_TEXT_2:
      "Any changes you make to the system (excluding those that are still pending GoodShape approval) will be applied at this time.",
    RECENT_REVIEWS: "Recent Reviews",
    DRAFTS_IN_PROGRESS: "Drafts In Progress",
    CHANGES_LAST_30_DAYS: "Changes Last 30 Days",
    APPROVED: "Approved",
    BLOCKED: "Blocked",
    DEFERRED: "Deferred",
    COMPLETED_CHANGES: "Completed Changes",
    DELETE_CHANGE_SET_MODAL_TITLE: "Delete Change Set",
    DELETE_CHANGE_SET_CONFIRMATION: "Are you sure would like to delete {reason} change set?",
    DELETE_CHANGE_SETS_CONFIRMATION: "Are you sure would like to delete selected change sets?",
    CHANGE_SET_FILTER_FROM_DATE: "From Date",
    CHANGE_SET_FILTER_TO_DATE: "To Date",

    // Dynamic Questions
    CALL_SCRIPTING: "Call Scripting",
    DYNAMIC_QUESTIONS_LIVE: "Live Dynamic Questions",
    DYNAMIC_QUESTIONS_LIVE_FC: "Live Dynamic Questions FC",
    DYNAMIC_QUESTIONS_LIVE_EMPTY: "No Live Dynamic Questions to review",
    DYNAMIC_QUESTIONS_LIVE_EMPTY_FC: "No Live Dynamic Questions to review",
    DYNAMIC_QUESTIONS_PENDING_REVIEW: "Dynamic Questions Pending Review",
    DYNAMIC_QUESTIONS_PENDING_REVIEW_FC: "Dynamic Questions Pending Review FC",
    DYNAMIC_QUESTIONS_PENDING_REVIEW_EMPTY: "No Pending Dynamic Questions to review",
    DYNAMIC_QUESTIONS_PENDING_REVIEW_EMPTY_FC: "No Pending Dynamic Questions to review",
    DYNAMIC_QUESTIONS_DRAFT_FC: "Dynamic Questions Drafts FC",
    DYNAMIC_QUESTIONS_DRAFT: "Dynamic Questions Drafts",
    DYNAMIC_QUESTIONS_DRAFT_EMPTY: "No Draft Dynamic Questions to review",
    DYNAMIC_QUESTIONS_DRAFT_EMPTY_FC: "No Draft Dynamic Questions to review",
    QUESTION_TEXT: "Question Text",
    QUESTION_TYPE: "Question Type",
    ADVISOR_TYPE: "Advisor Type",
    BENCHMARKING: "Benchmarking",
    ADVISOR_TYPE_TOOLTIP:
      "Use this field to determine whether the question is to be asked by either an Absence Advisor or a Nurse Advisor.",
    IS_ACTIVE_TOOLTIP:
      "Use this field to alter the status of a standard question. Questions can be set to being either 'active' or 'inactive'.",
    MANDATORY: "Mandatory",
    START_NOTIFICATION: "Start Notification",
    UPDATE_NOTIFICATION: "Update Notification",
    CLOSE_NOTIFICATION: "Close Notification",
    DYNAMIC_QUESTION_ACTION_START_DRAFT: "Start Dynamic Question Draft",
    DYNAMIC_QUESTION_ACTION_VIEW_CURRENT_DRAFT: "View Current Dynamic Question Draft",
    DYNAMIC_QUESTION_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    DYNAMIC_QUESTION_ACTION_DUPLICATE_SETUP: "Duplicate Dynamic Question",
    DYNAMIC_QUESTION_ACTION_DISABLE_SETUP: "Disable Dynamic Question",
    DYNAMIC_QUESTION_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    DYNAMIC_QUESTION_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    DYNAMIC_QUESTION_ACTION_EDIT_REASON_SPECIFIC_USAGE: "Edit Reason Specific Usage",
    DYNAMIC_QUESTION_ACTION_DISCARD_DRAFT: "Discard Draft",
    DYNAMIC_QUESTION_ACTION_EDIT_LENGTH_SCOPE: "Edit Length Scope",
    DYNAMIC_QUESTION_ACTION_EDIT_ANSWER_OPTIONS: "Edit Answer Options",
    DYNAMIC_QUESTION_ACTION_EDIT_QUESTION_TYPE: "Edit Question Type",
    PENDING_REVIEW: "Pending Review",
    PENDING_REVIEW_FC: "Pending Review",
    ADD_DYNAMIC_QUESTION_MODAL_TITLE: "Add New Question",
    ADD_QUESTION_MODAL_STEP_1_TITLE: "{step}/{totalSteps} Question Type",
    ADD_QUESTION_MODAL_STEP_2_TITLE: "{step}/{totalSteps} Hierarchy Scope",
    ADD_QUESTION_MODAL_STEP_3_TITLE: "{step}/{totalSteps} Reason Scope",
    ADD_QUESTION_MODAL_STEP_4_TITLE: "{step}/{totalSteps} Length Scope",
    ADD_QUESTION_MODAL_STEP_5_TITLE: "{step}/{totalSteps} Answer Options",
    STAFF_GROUPS_STEP_TITLE: "{step}/{totalSteps} Staff Groups",
    ANSWER_OPTION: "Answer Option",
    ADD_ANSWER_OPTION: "Add Answer Option",
    REASON_RESTRICTION: "Reason Restriction",
    HIERARCHY_RESTRICTION: "Hierarchy Restriction",
    DURATION_DAYS: "Duration Days",
    DYNAMIC_QUESTION_DETAILS: "Dynamic Question #{providerId}",
    DYNAMIC_QUESTION_DRAFT: "Draft for Dynamic Question #{providerId}",
    DYNAMIC_QUESTION_LAST_UPDATED_BY: "Last edited by:",
    EDIT_CURRENT_DRAFT: "Edit Current Draft",
    CANCEL_REVIEW: "Cancel Review",
    DYNAMIC_QUESTION_DETAILS_QUESTION_TYPE: "Question Type",
    DYNAMIC_QUESTION_DETAILS_REASON_SCOPE: "Reason Scope",
    DYNAMIC_QUESTION_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    DYNAMIC_QUESTION_DETAILS_LENGTH_SCOPE: "Length Scope",
    DYNAMIC_QUESTION_DETAILS_ANSWER_OPTIONS: "Answer Options",
    EDIT_DYNAMIC_QUESTION_MODAL_TITLE: "Edit Dynamic Question #{providerId}",
    APPROVABLE_TYPE_DYNAMIC: "Question",
    APPROVABLE_TYPE_EAP: "EAP Set-Up",
    APPROVABLE_TYPE_REASON: "Reason",
    ADVISOR_ONLY: "Absence Advisor Only",
    NURSE_ONLY: "Nurse Advisor Only",
    TARGETED: "Targeted",

    // System access
    LOGO: "Logo",
    UPLOAD: "Upload",
    UPLOAD_LOGO: "Upload Logo",
    NO_LOGO_PROVIDED: "No logo provided",
    PASSWORD_RESET: "Password Reset",
    PASSWORD_RESET_REQUIREMENT: "Password Reset Requirement",
    PASSWORD_RESET_REQUIREMENT_MANAGERS: "Managers Are Required to Reset Password",
    PASSWORD_RESET_REQUIREMENT_EMPLOYEES: "Employees Are Required to Reset Password",
    EVERY_X_DAYS: "Every {days} days",
    INACTIVITY_IN_MINUTES: "{minutes} minutes of Inactivity",
    FAILED_LOGIN_ATTEMPTS: "{times} Failed Login Attempts",
    LOG_OUT_AND_LOCK: "Log Out and Lock",
    LOG_OUT_USER_AFTER: "Log Out User Automatically After",
    LOCK_USER_AFTER: "Lock User Account After",
    ADD_IP_RESTRICTION: "Add IP Restriction",
    IP_ADDRESS_RESTRICTION_ACTIVE: "IP Address Restriction Active",
    IP_ADDRESS_RESTRICTION_INACTIVE: "IP Address Restriction Inactive",
    RECORDS_SELECTED: "{numberOfRecords} records selected",
    DEFAULT_INTRODUCTION_TEXT: "Default Introduction Text",
    FULL_HR_ACCESS_INTRODUCTION_TEXT: "Full HR Access Introduction Text",
    LINE_MANAGER_INTRODUCTION_TEXT: "Line Manager Introduction Text",
    ADVANCED_USER_INTRODUCTION_TEXT: "Advanced User Introduction Text",
    EMPLOYEE_INTRODUCTION_TEXT: "Employee Introduction Text",
    EDIT_STANDARD_REGISTRATION_EMAILS: "Edit Standard Registration Emails",
    MULTI_FACTOR_AUTHENTICATION: "Multi-Factor Authentication",
    MULTI_FACTOR_AUTHENTICATION_ACTIVE: "Multi-Factor Authentication Active",
    MULTI_FACTOR_AUTHENTICATION_INACTIVE: "Multi-Factor Authentication Inactive",
    MULTI_FACTOR_AUTHENTICATION_CONFIRMATION_TEXT:
      "Are you sure you want to enable Multi-Factor Authentication? This change will apply to all users",
    CONFIRM_MFA: "Yes, enable MFA",

    // Default Standard Scripts
    DEFAULT_SCRIPTS: "Default Scripts",
    DEFAULT_STANDARD_SCRIPTS_LIVE_FC: "Live Default Standard Scripts FC",
    DEFAULT_STANDARD_SCRIPTS_LIVE: "Live Default Standard Scripts",
    DEFAULT_STANDARD_SCRIPTS_PENDING_REVIEW_FC: "Default Standard Scripts Pending Review FC",
    DEFAULT_STANDARD_SCRIPTS_PENDING_REVIEW: "Default Standard Scripts Pending Review",
    DEFAULT_STANDARD_SCRIPTS_PENDING_REVIEW_EMPTY_FC:
      "No Pending Default Standard Scripts to review",
    DEFAULT_STANDARD_SCRIPTS_PENDING_REVIEW_EMPTY: "No Pending Default Standard Scripts to review",
    DEFAULT_STANDARD_SCRIPTS_DRAFT_FC: "Default Standard Scripts Drafts FC",
    DEFAULT_STANDARD_SCRIPTS_DRAFT: "Default Standard Scripts Drafts",
    DEFAULT_STANDARD_SCRIPTS_DRAFT_EMPTY: "No Draft Default Standard Scripts to review",
    SCRIPT_TYPE: "Script Type",
    SCRIPT_TEXT: "Script Text",
    DEFAULT_STANDARD_SCRIPT_ACTION_START_DRAFT: "Start Default Standard Script Draft",
    DEFAULT_STANDARD_SCRIPT_ACTION_VIEW_CURRENT_DRAFT: "View Current Default Standard Script Draft",
    DEFAULT_STANDARD_SCRIPT_ACTION_DISABLE_SETUP: "Disable Default Standard Script",
    DEFAULT_STANDARD_SCRIPT_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT:
      "Cancel Review and Resume Editing",
    DEFAULT_STANDARD_SCRIPT_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT:
      "Cancel Review and Discard Draft",
    DEFAULT_STANDARD_SCRIPT_ACTION_EDIT_SCRIPT_TEXT: "Edit Script Text",
    DEFAULT_STANDARD_SCRIPT_SCRIPT_TEXT: "Edit Script Text",
    DEFAULT_STANDARD_SCRIPT_ACTION_DISCARD_DRAFT: "Discard Draft",
    DEFAULT_STANDARD_SCRIPT_DRAFT: "Draft for Default Standard Script #{providerId}",
    DEFAULT_STANDARD_SCRIPT_LAST_UPDATED_BY: "Last edited by:",
    DEFAULT_STANDARD_SCRIPT_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    EDIT_FOR_SCRIPT: "Edit for {scriptName}",
    MAIN_DETAILS: "Main Details",
    LOCKED_DEPENDENCIES: "This section is locked and cannot be edited due to a dependency.",

    // Department Specific Scripts
    DEPARTMENT_SCRIPTS: "Department Scripts",
    HIERARCHY_AREAS: "Hierarchy Areas",
    DEPARTMENT_SPECIFIC_SCRIPTS_LIVE_FC: "Live Department Specific Scripts FC",
    DEPARTMENT_SPECIFIC_SCRIPTS_LIVE: "Live Department Specific Scripts",
    ADD_DEPARTMENT_SPECIFIC_SCRIPT: "Add Department Specific Script",
    DEPARTMENT_SPECIFIC_SCRIPTS_LIVE_EMPTY_FC: "No Live Department Specific Scripts to review",
    DEPARTMENT_SPECIFIC_SCRIPTS_LIVE_EMPTY: "No Live Department Specific Scripts to review",
    DEPARTMENT_SPECIFIC_SCRIPTS_PENDING_REVIEW_FC: "Department Specific Scripts Pending Review FC",
    DEPARTMENT_SPECIFIC_SCRIPTS_PENDING_REVIEW: "Department Specific Scripts Pending Review",
    DEPARTMENT_SPECIFIC_SCRIPTS_PENDING_REVIEW_EMPTY_FC:
      "No Pending Department Specific Scripts to review",
    DEPARTMENT_SPECIFIC_SCRIPTS_PENDING_REVIEW_EMPTY:
      "No Pending Department Specific Scripts to review",
    DEPARTMENT_SPECIFIC_SCRIPTS_DRAFT_FC: "Department Specific Scripts Drafts FC",
    DEPARTMENT_SPECIFIC_SCRIPTS_DRAFT: "Department Specific Scripts Drafts ",
    DEPARTMENT_SPECIFIC_SCRIPTS_DRAFT_EMPTY: "No Draft Department Specific Scripts to review",
    DEPARTMENT_SPECIFIC_SCRIPTS_DRAFT_EMPTY_FC: "No Draft Department Specific Scripts to review",
    ADD_DEPARTMENT_SPECIFIC_SCRIPT_MODAL_TITLE: "Add Department Specific Script",
    ADD_DEPARTMENT_SPECIFIC_SCRIPT_STEP_1_TITLE: "Main Details",
    ADD_DEPARTMENT_SPECIFIC_SCRIPT_MODAL_STEP_2_TITLE: "Hierarchy Area",
    ADD_DEPARTMENT_SPECIFIC_SCRIPT_STEP_1_NEXT_BUTTON: "Next: Hierarchy Area",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_START_DRAFT: "Start Department Specific Script Draft",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_VIEW_CURRENT_DRAFT:
      "View Current Department Specific Script Draft",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_DUPLICATE_SETUP: "Duplicate Department Specific Script",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_DISABLE_SETUP: "Disable Department Specific Script",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT:
      "Cancel Review and Resume Editing",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT:
      "Cancel Review and Discard Draft",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_EDIT_MAIN_DETAILS: "Edit Main Details",
    DEPARTMENT_SPECIFIC_SCRIPT_ACTION_DISCARD_DRAFT: "Discard Draft",
    APPROVABLE_TYPE_DEPARTMENT_SPECIFIC_SCRIPT: "Department Script",
    EDIT_DEPARTMENT_SPECIFIC_SCRIPT_HIERARCHY_SCOPE_MODAL_TITLE_FC:
      "Hierarchy Scope for Department Specific Script",
    EDIT_DEPARTMENT_SPECIFIC_SCRIPT_HIERARCHY_SCOPE_MODAL_TITLE:
      "Hierarchy Scope for Department Specific Script",
    EDIT_DEPARTMENT_SPECIFIC_SCRIPT: "Edit Department Specific Script",
    DEPARTMENT_SPECIFIC_SCRIPT_DETAILS: "Department Specific Script #{providerId}",
    DEPARTMENT_SPECIFIC_SCRIPT_DRAFT: "Draft #{providerId}",
    DEPARTMENT_SPECIFIC_SCRIPT_LAST_UPDATED_BY: "Last edited by:",
    DEPARTMENT_SPECIFIC_SCRIPT_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    DEPARTMENT_SPECIFIC_SCRIPT_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    DEPARTMENT_SPECIFIC_SCRIPT_DETAILS_LIVE_DATA_BANNER:
      "Following Below Is Live Data Associated with This Department Specific Script!",
    DETAILS_LIVE_DATA_BANNER_ADDITIONAL:
      "Note: Editing this data is outside the draft-review process and updates will take effect immediately.",
    DETAILS_HIERARCHY_SCOPE: "Hierarchy Scope",
    DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    DRAFT_FOR_NAME: "Draft for {name}",
    EDIT_FOR_NAME: "Edit for {name}",

    // Reason Specific Scripts
    REASON_SCRIPTS: "Reason Scripts",
    ADD_REASON_SPECIFIC_SCRIPT: "Add Reason Specific Script",
    REASON_SPECIFIC_SCRIPTS_LIVE_EMPTY: "No Live Reason Specific Scripts to review",
    ADD_REASON_SPECIFIC_SCRIPT_MODAL_TITLE: "Add Reason Specific Script",
    ADD_REASON_SPECIFIC_SCRIPT_STEP_1_TITLE: "Main Details",
    ADD_REASON_SPECIFIC_SCRIPT_MODAL_STEP_2_TITLE: "Hierarchy Area",
    ADD_REASON_SPECIFIC_SCRIPT_STEP_1_NEXT_BUTTON: "Next: Hierarchy Area",
    REASON_SPECIFIC_SCRIPT_ACTION_START_DRAFT: "Start Reason Specific Script Draft",
    REASON_SPECIFIC_SCRIPT_ACTION_VIEW_CURRENT_DRAFT: "View Current Reason Specific Script Draft",
    REASON_SPECIFIC_SCRIPT_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    REASON_SPECIFIC_SCRIPT_ACTION_DUPLICATE_SETUP: "Duplicate Reason Specific Script",
    REASON_SPECIFIC_SCRIPT_ACTION_DISABLE_SETUP: "Disable Reason Specific Script",
    REASON_SPECIFIC_SCRIPT_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    REASON_SPECIFIC_SCRIPT_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT:
      "Cancel Review and Discard Draft",
    REASON_SPECIFIC_SCRIPT_ACTION_EDIT_MAIN_DETAILS: "Edit Main Details",
    REASON_SPECIFIC_SCRIPT_ACTION_DISCARD_DRAFT: "Discard Draft",
    REASON_SPECIFIC_SCRIPT: "Reason Script #{reasonId}",
    EDIT_REASON_SPECIFIC_SCRIPT_HIERARCHY_SCOPE_MODAL_TITLE_FC:
      "Hierarchy Scope for Reason Specific Script",
    EDIT_REASON_SPECIFIC_SCRIPT_HIERARCHY_SCOPE_MODAL_TITLE:
      "Hierarchy Scope for Reason Specific Script",
    EDIT_REASON_SPECIFIC_SCRIPT: "Edit Reason Specific Script",
    REASON_SPECIFIC_SCRIPT_DETAILS: "Reason Specific Script #{providerId}",
    REASON_SPECIFIC_SCRIPT_DRAFT: "Draft #{providerId}",
    REASON_SPECIFIC_SCRIPT_LAST_UPDATED_BY: "Last edited by:",
    REASON_SPECIFIC_SCRIPT_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    REASON_SPECIFIC_SCRIPT_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    REASON_SPECIFIC_SCRIPT_DETAILS_LIVE_DATA_BANNER:
      "Following Below Is Live Data Associated with This Reason Specific Script!",
    SCRIPT_NAME: "Script Name",

    // Standard Questions
    STANDARD_QUESTION: "Standard Question",
    STANDARD_QUESTIONS_LIVE_EMPTY: "No Live Standard Questions to review",
    STANDARD_QUESTIONS_LIVE_EMPTY_FC: "No Live Standard Questions to review",
    STANDARD_QUESTIONS_PENDING_REVIEW: "Standard Questions Pending Review",
    STANDARD_QUESTIONS_PENDING_REVIEW_EMPTY: "No Pending Standard Questions to review",
    STANDARD_QUESTIONS_PENDING_REVIEW_EMPTY_FC: "No Pending Standard Questions to review",
    STANDARD_QUESTIONS_DRAFT: "Standard Questions Drafts",
    STANDARD_QUESTIONS_DRAFT_EMPTY: "No Draft Standard Questions to review",
    STANDARD_QUESTIONS_DRAFT_EMPTY_FC: "No Draft Standard Questions to review",
    STANDARD_QUESTION_ACTION_VIEW_CURRENT_DRAFT: "View Current Standard Question Draft",
    STANDARD_QUESTION_ACTION_EDIT_HIERARCHY_SCOPE: "Edit Hierarchy Scope",
    STANDARD_QUESTION_ACTION_DUPLICATE_SETUP: "Duplicate Standard Question",
    STANDARD_QUESTION_ACTION_DISABLE_SETUP: "Disable Standard Question",
    STANDARD_QUESTION_ACTION_CANCEL_REVIEW_AND_RESUME_EDIT: "Cancel Review and Resume Editing",
    STANDARD_QUESTION_ACTION_CANCEL_REVIEW_AND_DISCARD_DRAFT: "Cancel Review and Discard Draft",
    STANDARD_QUESTION_ACTION_EDIT_REASON_SPECIFIC_USAGE: "Edit Reason Specific Usage",
    STANDARD_QUESTION_ACTION_DISCARD_DRAFT: "Discard Draft",
    STANDARD_QUESTION_ACTION_EDIT_LENGTH_SCOPE: "Edit Length Scope",
    STANDARD_QUESTION_ACTION_EDIT_ANSWER_OPTIONS: "Edit Answer Options",
    STANDARD_QUESTION_ACTION_EDIT_QUESTION_TYPE: "Edit Question Type",
    ADD_STANDARD_QUESTION_MODAL_TITLE: "Add New Question",
    STANDARD_QUESTION_DETAILS: "Standard Question - {name}",
    STANDARD_QUESTION_DRAFT: "Draft for {name}",
    STANDARD_QUESTION_LAST_UPDATED_BY: "Last edited by:",
    STANDARD_QUESTION_DETAILS_QUESTION_TYPE: "Question Type",
    STANDARD_QUESTION_DETAILS_REASON_SCOPE: "Reason Scope",
    STANDARD_QUESTION_DETAILS_SECTION_EMPTY: "This section has not been completed yet.",
    STANDARD_QUESTION_DETAILS_LENGTH_SCOPE: "Length Scope",
    STANDARD_QUESTION_DETAILS_ANSWER_OPTIONS: "Answer Options",
    EDIT_STANDARD_QUESTION_MODAL_TITLE: "Edit Standard Question #{providerId}",
    APPROVABLE_TYPE_STANDARD: "Standard Question",
    STANDARD_QUESTION_ACTION_EDIT_MAIN_DETAILS: "Edit Main Details",
    STANDARD_QUESTION_DETAILS_LOCKED_PENDING_REVIEW:
      "This draft is locked and cannot be edited as it is pending review.",
    STANDARD_QUESTION_DETAILS_LIVE_DATA_BANNER:
      "Following Below Is Live Data Associated with This Standard Question!",
    ADD_STANDARD_QUESTION_MODAL_STEP_2_TITLE_TOOLTIP:
      "Use this tool to select which area(s) within your organisation's hierarchy your standard question will apply to. This is done by ticking the name of the desired location(s). Your chosen areas will appear under the column title 'Areas Included', whilst areas you may choose to deselect (i.e. those outside desired scope) will appear under the column title 'Areas Excluded'. Your standard question applies only to areas which are listed under the 'Areas Included' column. Note that 'child' units are included when a 'parent' is selected to be within scope.",

    ONE_PER_ABSENCE: "One per Absence",
    ALL_FULL_CONTACTS: "All full contacts",
    ALL_REASONS: "All reasons",
    ONE_PER_ROLE: "One per role",
    RTW_CONTACTS_OF_ABSENCE_ONLY: "RTW contacts of absence only",

    // REFERRAL SUPPLIER DETAILS
    SUPPLIER_ID: "Supplier ID",
    SUPPLIER_NAME: "Supplier Name",
    SUPPLIER_DESCRIPTION: "Supplier Description",
    EMAIL_ADDRESS: "Email Address",
    SERVICE_PROVIDED: "Service Provided",
    MANAGER_REFERRALS: "Manager Referrals",
    EMPLOYEE_REFERRALS: "Employee Referrals",
    SUPPLIER: "Supplier",

    EMAILS: "Emails",
    NEW_ACCOUNTS: "New Accounts",
    EXISTING_ACCOUNTS: "Existing Accounts",
    MANAGERS_HR_REGISTRATIONS: "Managers & HR Registrations",
    BULK_REGISTRATIONS_TEXT:
      "There are {count} full notification contacts who do not have an active GoodShapeCentral account.",
    SEND_BULK_EMAILS: "Send Bulk Registration Emails",
    SEND_BULK_EMAILS_TEXT1:
      "This will create and issue {count} GoodShapeCentral registration emails (one for each Full Notification contact without an existing account).",
    SEND_BULK_EMAILS_TEXT2: "Are you sure you wish to continue?",
    EMPLOYEE_REGISTRATIONS: "Employee Registrations",
    EMPLOYEE_REGISTRATIONS_TEXT:
      "There are {count} employees who do not have an active GoodShapeCentral account.",
    SEND_EMPLOYEE_EMAILS: "Send Employee Registration Emails",
    SEND_EMPLOYEE_EMAILS_TEXT1:
      "This will create and issue {count} GoodShapeCentral registration emails (one for each Employee without an existing account).",
    STANDARD_REGISTRATION_EMAILS: "Standard Registration Emails",
    SECTION_LOCKED: "This section is locked and cannot be edited due to pending {name} changes.",
    ANY: "Any",
    UPDATES_BATCHED_TOGETHER: "Updates batched together",
    NO_DUPLICATING_REASONS: "No duplicating reasons",
    EXCLUDE: "Exclude",
    REVIEW_BULK_REGISTRATION_ADDRESSES: "Review Bulk Registration Addresses",
    STEP_1_OF_2_SELECT_EMPLOYEE: "1/2 Select Employee",
    STEP_2_OF_2_HIERARCHY_SCOPE: "2/2 Hierarchy Scope",
    SCHEDULED_REPORTS: "Scheduled Reports",
    SCHEDULED_REPORT_ACCESS: "Scheduled Report Access",
    OCCURRENCES: "Occurrences",
    INACTIVE_REASON_LABEL: "Please select active reason!",
    INACITIVE_REASONS_WARNING: "One or more Absence Reasons are inactive. Please, remove them!",
    ENABLE_SCHEDULED_REPORTS_BUTTON: "Yes, Enable Scheduled Reports",
    ENABLE_SCHEDULED_REPORTS_WARNING: "Are you sure want to enable Scheduled Reports?",
    ENABLE_SCHEDULED_REPORTS_WARNING_TEXT_1:
      "The security and confidentiality of your employee's personal information is of paramount importance to GoodShape. As such, we want to bring to your attention that, by enabling scheduled reports, your users will be able to access confidential information without the need to authenticate via a username, password or valid IP address.",
    ENABLE_SCHEDULED_REPORTS_WARNING_TEXT_2:
      "This is because links to download reports will be sent directly to the users mailbox, by-passing their need to login to the system. If this is an accepted and understood process then you can finish enabling Scheduled Reports using the button below. However, if you are uncertain about whether or not to proceed we suggest pressing the Cancel button and consulting with your Information Governance team.",
    CHARS_LEFT: `<strong class="text-color-pumpkin-orange">{count}</strong> Characters Left`,
    APP_STATUS: "App Status",
    ONBOARDED: "Onboarded",
    NOT_ONBOARDED: "Not Onboarded",
    DATE_ONBOARDED: "Date Onboarded",

    // Help panel scripts
    SCRIPTS_INTRODUCTION:
      "The Scripts page enables you to edit the messages that are read out by GoodShape call handlers (when your employees call our Service Centre), or which appear in the GoodShape app, during certain steps of the Absence Reporting process.",
    SCRIPTS_INSTRUCTIONS: "Scripts Instructions",

    FIRST_TIME_CALLER: "First Time Caller",
    OPTION_TO_CLOSE: "Option to Close",
    AUTO_ID_CALLER_IDENTITY: "AUTO ID Caller Identity",
    AUTO_ID_CLIENT_MATCH: "AUTO ID Client Match",
    SCRIPTS_OVERRIDES: "Scripts Overrides",
    IMPROTANT_MESSAGES: "Important Messages",

    SCRIPTS_FIRST_TIME_CALLER_DESCRIPTION:
      "This script is read-out to an employee when they call GoodShape for the very first time. Service Centre only.",
    SCRIPTS_MINIMUM_ABSENCE_DURATION_DESCRIPTION:
      "This script is read-out to an employee if they attempt to report an absence that is shorter than the minimum duration specified by your organisation on the Settings page. Service Centre only.",
    SCRIPTS_SHIFT_PATTER_DESCRIPTION:
      "This script is read out to employees when asking them to confirm their working pattern for the duration of their absence. Service Centre only.",
    SCRIPTS_OPTION_TO_CLOSE_DESCRIPTION:
      "This script is read out to employees when their absence is eligible to be closed. Service Centre only.",
    SCRIPTS_ID_CALLER_IDENTITY_DESCRIPTION:
      "This is the greeting read out by a GoodShape call handler to an employee that has already self-identified via the telephone system.  Service Centre only.",
    SCRIPTS_ID_CLIENT_MATCH_DESCRIPTION:
      "This is the greeting read out by a GoodShape call handler to an employee whose attempt to self-identify via the phone system was not successful.  Service Centre only.",
    SCRIPTS_OVERRIDES_DESCRIPTION:
      "All default scripts apply to all of your employees. However, you can set a department specific scripts to override the default one. This is useful if you want to relay a message to employees in a specific department and to no one else. Service Centre only.",
    SCRIPTS_IMPORTANT_MESSAGES_DESCRIPTION:
      "Here you can configure messages that you want shared with employees whenever they report absences due to specific absence reasons. This applies only to the calls made into the GoodShape Service Centre. To relay important messages for certain absence reasons via the app, please configure them in the Wellbeing section of the Notifications page.",

    // Help panel service page
    SERVICE_INTRODUCTION:
      "The Services Hub allows you to promote your other Health and Wellbeing Services to your employees via the GoodShape app. If you receive services from one of the suppliers listed, you can configure them immediately. If you work with a supplier that is not listed, please contact your Client Success Manager to get them added.",
    SERVICE_INSTRUCTIONS: "Service Instructions",
    APP_PROMOTION: "App Promotion",
    SERVICE_DIRECTORY: "Service Directory",
    ABSENCE_SUPPORT: "Absence Support",
    USER_REVIEWS: "User Reviews",
    ABOUT_SERVICE: "About This Service",
    SERVICE_HOW_TO_ACCESS: "How to Access This Service",
    WEBSITE: "Website",
    ANNUAL_SPEND: "Annual Spend (Optional)",
    USER_NAME_OPTIONAL: "User Name (Optional)",
    PASSWORD_OPTIONAL: "Password (Optional)",

    SERVICE_DIRECTORY_DESCRIPTION:
      "Any wellbeing services you configure on GoodShapeCentral will appear in the Service Directory on the GoodShape app. Your employees will be able to see and select the service while browsing.",
    ABSENCE_SUPPORT_DESCRIPTION:
      "If a Wellbeing Service you configure on GoodShapeCentral would be of value to an employee, based on their reason for absence, it will be presented to them on the absence confirmation screen. The employee can then click on the service to learn more details and see how to access it.",
    USER_REVIEWS_DESCRIPTION:
      "If your employee makes use of a Wellbeing Service you provide, they will have the option of leaving a review of the service. This enables GoodShape to provide you with reports and insight into employee satisfaction with your health and wellbeing services.",

    PROVIDED_NAME_DESCRIPTION:
      "If you do not see your provider listed, it means they have not been approved for being featured in GoodShape yet. Please submit a request to your Client Success manager to get your provider approved.",
    SERVICE_TYPES_DESCRIPTION:
      "When editing or adding a Service provider, you must select which types of services they provide. The Service Types you select will automatically control which category the service appears under in the Services Directory on the GoodShape app, and what absence reasons they are recommended for.",
    SERVICE_ABOUT_DESCRIPTION:
      "Provide a description of the service and the issues it can help with. This information is displayed on the app when the user clicks to view the Service. It’s recommended to be no longer than a paragraph.",
    SERVICE_HOW_TO_ACCESS_DESCRIPTION:
      "Provide a brief description of how an employee can access the service. This information is displayed on the app when the user clicks to view the Service. It’s recommended to be as concise and instructive as possible.",
    WEBSITE_DESCRIPTION:
      "Add the web address for a website the provider makes available. This field is optional but if populated the website must start with http…",
    PHONE_NUMBER_DESCRIPTION:
      "Add a phone number for the wellbeing service that employees can use to contact them.",
    ANNUAL_SPEND_DESCRIPTION:
      "Add your annual spend on the provider. This field is completely optional but, if populated, enables GoodShape to explore the creation of return on investment reports and analysis with your wellbeing team.",
    USER_NAME_OPTIONAL_DESCRIPTION:
      "If there is a generic username that employees can use to access the service confidentiality, such as for an EAP Service, enter this here. This information appears in a “Credentials” section of the Service page in the GoodShape app, so that the user can copy and use it.",
    PASSWORD_OPTIONAL_DESCRIPTION:
      "If there is a generic password that employees can use to access the service confidentiality, such as for an EAP Service, enter this here. This information appears in a “Credentials” section of the Service page in the GoodShape app, so that the user can copy and use it.",
    HIERARCHY_AREA_DESCRIPTION:
      "Select the Hierarchy Scope that the service is available to. The service will only be featured in the app for employees that are assigned to a department within the hierarchy scope.",

    SECURITY_INTRODUCTION:
      "The Security page lets you manage how users access GoodShapeCentral, what email domains are permitted, and what controls are in place for viewing employee records.",
    SECURITY_INSTRUCTIONS: "Security Instructions",
    TUTORIAL_SECURITY_SETTINGS: "Tutorial: Security Settings",

    SECURITY_FAILURE_DESCRIPTION:
      "This Setting controls how GoodShape staff must proceed when speaking to an employee who gets their Security Question wrong when having their identity verified.",
    SECURITY_QUESTION_DESCRIPTION:
      "Enables you to select which 3 Security Question options are made available for your employees to choose from when setting up their GoodShape profile.",

    ABSENCE_REASONS_INFORMATION:
      "Absence Reasons are the list of options your employees can choose from when reporting an absence. There is no limit to how many reasons you can have active, but we recommend no more than 60 so that the process of finding and choosing a reason is straightforward for your employees. You can add both medical and non-medical reasons to the list.",
    SHIFT_PATTERNS_INFORMATION:
      "Shift Patterns are pre-configured working patterns that cover a 7 day period. They are designed for employees with a static working pattern that remains the same each week. All active shift patterns are listed in the GoodShape App and can be selected by your employees. When an employee is assigned a shift pattern, it is automatically used to populate the time lost of their absence.",
    STAFF_GROUPS_INFORMATION:
      "You may have many employees who perform similar job roles in different parts of your hierarchy. Staff Groups enable you to group those employees together as a population. Absence Reports and Absence Policy Alerts can all be filtered to only include certain Staff Groups. This means that you can set the system up to only perform certain actions for certain types of employee.",
    ALERTS_INFORMATION:
      "Alerts are used to trigger events whenever an employee's absence meets a specific threshold, or follows a certain pattern. They can be set-up to trigger absence policy alerts, wellbeing referrals or absence monitoring reviews. Each alert can be customised to have its own rules, content and recipients. They can also be restricted to certain staff groups of hierarchy areas.",
    RTW_INFORMATION:
      "Return to Work Interview forms are used to provide managers with a set of questions to ask an employee when they return to work following a period of absence. Custom forms can be created based on absence reason, absence length and hierarchy area. Each form can also have a compliance measure set for it, as well as overdue reminders.",
    ABSENCE_MONITORING_INFORMATION:
      "GoodShape Monitor enables you to configure your organisation's attendance management procedure. It is designed to include each stage of the process, from initial warning to dismissal. You can add an unlimited number of stages, and each stage can have its own permissions and options. You can also configure review periods and KPI targets for managers.",
    WELLBEING_REFERRALS_INFORMATION:
      "GoodShape Navigator enables you to configure referrals to treatment providers, such as Occupational Health. It can be used to send referrals to both internal and external teams, and supports both manager and self-referrals. The Questions that appear on the referral form can also be configured. Note that referrals will only trigger if they are linked to an active alert.",
    QUESTIONS_INFORMATION:
      "Questions appear on the absence reporting form and will be seen by your employees when they report a qualifying absence. Questions can be configured to appear only in certain circumstances, such as for specific absence reasons, certain hierarchy areas, or a selection of staff groups. They can also be set to mandatory to force employees to provide an answer.",
    PLATFORM_INFORMATION:
      "These are global settings that control the absence reporting rules, as well as which App and AI related features are available. These are global settings that apply across the platform for all departments and users.",
    REPORTS_INFORMATION:
      "These settings relate to the reports in GoodShape Central and will impact what options are available to users when they attempt to filter the results of a report. This is also where scheduled report permissions are managed.",
    SECURITY_SETTINGS_INFORMATION:
      "These settings focus on keeping customer data as safe and secure as possible. Here you can manage system access rules, emails domains, multi-factor authentication and manager self-service permissions.",
    ACCOUNT_SETTINGS_INFORMATION:
      "These settings are used to manage the client organisation itself and what products and services they have purchased from GoodShape. Many of these settings will control the appearance of features elsewhere in the system.",
    FEATURES_MESSAGES_INFO:
      "Messages are prompts sent to employees who report absences classified with specific absence reasons, such as mental health issues or back problems. The messages are sent via SMS Text Message and In-App Notifications to relevant employees and are a useful way to share important instructions or promote wellbeing services.",

    SERVICE_FEATURES_ABSENCE_REASONS_ALERTS:
      "It's best practice to ensure that each absence reason is covered by <strong>at least one alert</strong>. If a reason is not included in the scope of any alerts, then any absences classified with it may escape notice and not trigger review processes when they should.",
    SERVICE_FEATURES_ABSENCE_REASONS_MESSAGES:
      "Signposting messages are sent to employees via SMS Messages and In-App Notifications when they report or update an absence. These can be used to make employees aware of services that can help them, or applicable processes they need to be aware of. It's <strong>recommended to configure them</strong> for as many reasons as possible.",
    SERVICE_FEATURES_ABSENCE_REASONS_QUESTIONS:
      "It's best practice to have additional questions set-up <strong>for every absence reason</strong>. They provide an opportunity to find out more information about the root cause of the absence, and what actions the employee has taken. They can also be used to get employees to confirm acknowledgement of policies and their responsibilities.",
    SERVICE_FEATURES_ABSENCE_REASONS_REPORTS:
      "This column shows how many reports your HR team and Line Managers have created that include the absence reason. If a reason is not included in the scope of any reports, then any absences classified with it may escape notice and not attract the attention that they should.",
    SERVICE_FEATURES_ABSENCE_REASONS_RTW_FORMS:
      "The best practice is to have <strong>custom RTW forms for key absence reasons</strong>. A generic form, with the same questions for every absence, regardless of reason, can be limiting. Whereas, questions created specifically for the issue the employee has experienced, can help the manager to have a better quality interview, that both shows more support for the employees, and captures more useful information that may help to prevent a reoccurence of the issue.",

    SERVICE_FEATURES_RTW_TABLE_QUESTIONS:
      "Manager compliance rates are, on average, 9% higher for RTW forms that have <strong>between 11 and 25 questions</strong>. Too few questions, and the process appears unimportant, but with too many questions it can appear burdensome and make managers feel they do not have time for the task.",
    SERVICE_FEATURES_RTW_TABLE_ATTACHMENTS:
      "It's recommended to always have <strong>at least one attachment</strong>, such as a copy of relevant policies, forms, letters or leaflets that will either help the manager be more effective, or that can be shared with the employee to support their wellbeing.",
    SERVICE_FEATURES_RTW_TABLE_KPI_TARGET:
      "The earlier RTW Interviews are completed the better. This is to ensure the employee is fit to resume their duties, and also enable any relevant actions or applicable processes to be carried out promptly. Best practice is a <strong>KPI target of 48 Hours or less</strong>. If your organisation does not work on weekends or bank holidays, they can be excluded from the due date calculation via the Settings page. ",
    SERVICE_FEATURES_RTW_TABLE_EXPIRY:
      "This setting controls how soon a RTW Interview will be expired and removed from a manager's task queue if it is not completed. <strong>Best practice is 90 days</strong>. Any longer and tasks will be waiting around, clogging up manager task queues, and likely distracting them from newer, more pressing tasks. ",
    SERVICE_FEATURES_RTW_TABLE_LATE_CAPTURE:
      "The best practice is to <strong>enable this feature</strong>. This do will force managers to select a reason why they have done a RTW Interview late. This shows to the manager that there is monitoring in place and potential consequences for not completing tasks on-time.",

    LATE_CAPTURE: "Late Capture",
    EXPIRY: "Expiry",
    TRIGGER_POINT: "Trigger Point",
    RATING: "Rating",

    BEST_PRACTICE: "Best Practice",
    SERVICE_FEATURES_ALERTS_TABLE_ATTACHMENTS:
      "It's recommended to always have <strong>at least one attachment</strong>, such as a copy of relevant policies, forms, letters or leaflets that will either help the manager be more effective, or that can be shared with the employee to support their wellbeing.",
    SERVICE_FEATURES_ALERTS_TABLE_RECIPIENTS:
      "Ensure that your alert is set-up to be sent to <strong>at least one recipient</strong>. If there are not recipients for an alert, it will not be triggered. Recipients can either be pre-set roles (such as FULL notification contacts) or bespoke individuals.",
    SERVICE_FEATURES_ALERTS_TABLE_HIERARCHY_AREAS:
      "Ensure that your alert is set-up for <strong>at least one hierarchy area</strong>. If there is no hierarchy assigned to the alert, it will not trigger.",
    SERVICE_FEATURES_ALERTS_TABLE_HIERARCHY_FIELDS:
      "Alerts have to be informative and help a manager understand more about both the employee, and the absence that triggered the alert. It's recommended to include <strong>at least 3 pieces of information</strong> to help the manager understand the situation.",
    SERVICE_FEATURES_ALERTS_TABLE_HIERARCHY_TRIGGER_POINT:
      "The best practice is to have alerts that will trigger either at the <strong>Actual Time</strong> the criteria is met, <strong>or when it is Predicted</strong> to be met. Both of these settings mean that the alert is sent early and enables proactive management, rather than waiting until the absence is closed.",

    MANAGER_KPI: "Manager KPI",
    SUPLIER_KPI: "Supplier KPI",
    SERVICE_FEATURES_NAVIGATOR_TABLE_EMPLOYEE_REFERRAL:
      "It is recommended to have <strong>at least one criteria</strong> that allows an employee to self-refer into Occupational Health. However, such rules may be governed by your contract with your Occupational Health and may not be possible to do.",
    SERVICE_FEATURES_NAVIGATOR_TABLE_MANAGER_REFERRALS:
      "It is recommended to have <strong>at least one criteria</strong> that requires a manager to review a recommended Occupational Health referral, and decide whether or not to approve it. This helps to gate keep referrals and reinforce the line managers responsibilities.",
    SERVICE_FEATURES_NAVIGATOR_TABLE_MANAGER_KPI:
      "It's best practice to target managers with completing Occupational Health referrals <strong>within 3 days of being notified</strong>. This is so that decisions are made quickly and early intervention can take place. If your organisation does not work on weekends or bank holidays, they can be excluded from the decision due date calculation via the Settings page.",
    SERVICE_FEATURES_NAVIGATOR_TABLE_SUPPLIER_TRACKING:
      "Supplier tracking requires your Occupational Health (OH) team (whether they are internal or external) to login to GoodShape and acknowledge receipt of the referrals that have been sent to them. It's <strong>recommended to enable this setting</strong>, as it provides transparency on to the performance and response times of OH, and shows that they are being tracked and monitored.",
    SERVICE_FEATURES_NAVIGATOR_TABLE_SUPLIER_KPI:
      "It's best practice to target Occupational Health with acknowledging new referrals <strong>within 2 days of being sent</strong>. This is so that they pick up the referral and book in their initial assessments quickly. This will enable the appropriate treatment pathway to be identified quicker, which can help to return the employee back to work sooner.",

    SERVICE_FEATURES_MONITOR_TABLE_LEVELS:
      "It's best practice for an attendance management procedure to <strong>have at least 3 levels</strong> (inclusive of Level 0 - Not in Process). If a process has too few levels, it runs the risk of pushing employees through the levels too quickly, and may potentially be unfair.",
    SERVICE_FEATURES_MONITOR_TABLE_NO_ACTION_LIST:
      "Sometimes, your manager may choose to not take any action after competing an absence monitoring review. It's best practice to have <strong>at least 2 options</strong> for them to choose from to confirm the reason why, as you will get more insight into why managers choose to not apply your policies.",
    SERVICE_FEATURES_MONITOR_TABLE_SUPPORT_LIST:
      "As well as taking an employee through an attendance management procedure towards potential dismissal, it's important to also demonstrate what is being done to support the wellbeing of the employee. It's best practice to have <strong>at least 2 wellbeing actions</strong> that a manager can also log the completion of, so that this support is also documented.",
    SERVICE_FEATURES_MONITOR_TABLE_KPI_TARGET:
      "It's best practice to target managers with completing absence monitoring reviews <strong>within 7 calendar days</strong> of an employee triggering an alert. Earlier targets can be set, but run the risk of undermining the managers perceived effectiveness, as alerts are often triggered at the start, or in the middle, of the absence and the manager will often need to wait until they return to work in order to do the review.",
    SERVICE_FEATURES_MONITOR_TABLE_HIERARCHY_AREAS:
      "Ensure that your absence monitoring process is set-up for <strong>at least one hierarchy area</strong>. If there is no hierarchy assigned to the absence monitoring process, it will not generate any tasks.",

    TEXT_LENGTH: "Text Length",
    SERVICE_FEATURES_DQNAMIC_QUESTIONS_TABLE_QUESTION_TYPE:
      "It's best practice to <strong>avoid Free Text questions</strong>. While it is tempting to have open ended questions that permit any type of response, doing so limits the potential for data analysis and reporting on the question answers.",
    SERVICE_FEATURES_DQNAMIC_QUESTIONS_TABLE_MANDATORY:
      "It's best practice to make dynamic questions <strong>mandatory</strong>. This will force the employee to answer the questions and guarantee that you receive the information and can make use of it.",
    SERVICE_FEATURES_DQNAMIC_QUESTIONS_TABLE_TEXT_LENGTH:
      "The longer a question is, the greater the risk of the employee getting confused or misunderstanding what's expected. It's best practice to keep the question to <strong>100 characters or less</strong>. ",
    SERVICE_FEATURES_DQNAMIC_QUESTIONS_TABLE_HIERARCHY_AREAS:
      "Ensure that your alert is set-up for <strong>at least one hierarchy area</strong>. If there is no hierarchy assigned to the alert, it will not trigger.",
    SERVICE_FEATURES_DQNAMIC_QUESTIONS_TABLE_NOTIFICATIONS:
      "Ensure that you have <strong>enabled the answers to appear on absence notifications</strong>. If this is not done, line managers will not see the additional information and may miss important details that needed to be acted upon.",

    LEVELS: "Levels",
    NO_ACTION_LIST: "No Action List",
    SUPPORT_LIST: "Support List",

    INCLUDE_EMPLOYEE_REF: "Include Employee Ref",
    ABSENCE_NOTIFICATION_SWITCH_DESCRIPTION:
      "Notification Contacts are sent SMS Absence Notifications when employees report, updates or close absences. Sent within defined times only.",
    EMOLOYEE_REF_SWITCH_DESCRIPTION:
      "The Employee Reference number of the absent employee is included in absence notifications.",
    OVERDUE_REMINDERS_SWITCH_DESCRIPTION:
      "Employees are sent an SMS reminder if their absence is not closed on-time. These notifications are sent 24/7.",
    TEXT_TO_CLOSE_SWITCH_DESCRIPTION:
      "Employees can close their absence by text message in response to a message from GoodShape. These notifications are sent 24/7.",
    NOTIFICATIONS_SEND_TIMES: "Absence Notification SMS Send Times",

    THIS_ALERT_IS_SUPPRESSED_BY:
      "This alert is suppressed by these alerts and will not trigger if they do",
    ALERT_SUPPRESSION: "Alert suppression",
    ARE_YOU_SURE: "Are you sure ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ALERT: "Are you sure you want to delete alert#",
    ADD_ALERT_TO_SUPPRESS: "Add alert to suppress",
    AVAILABILITY: "Availability",
    THIS_ALERT_IS_SUPPRESSED_BY_INFO_BOX:
      "Your currently active alerts are listed below. Alerts are only available to suppress if they meet 3 specific criteria: 1) They are not already being suppressed by this alert, 2) They are not already suppressing an alert that suppresses this alert (Cascading Suppression) and 3) They are not suppressed by another alert that this alert suppresses.",
    ALERTS_THIS_ALERT_WILL_SUPPRESS: "Alerts this alert will suppress",
    ALERTS_THIS_ALERT_WILL_SUPPRESS_INFO_BOX:
      "Here you can add alerts that you want to be suppressed by this alert. This means that if an employee reports or updates an absence that trigger this alert, any alerts added below will not triggered at the same time, even if their criteria is met. This alert cannot suppress an alert that it is being suppressed by, as this would cause both alerts to not trigger.",
    NO_ALREADY_SUPPRESSED: "No. Already suppressed.",
    NO_SUPPRESSES_THIS_ALERT: "No. Suppresses this Alert",
    NO_ALREADY_SUPPRESSED_CASCADING: "No. Already suppressed cascading.",
    NO_CASCADING_SUPPRESSION_OF_THIS_ALERT: "No. Cascading suppression of this Alert",
    OVERDUE_ABSENCE_DEFAULT_TEXT:
      "This employee’s absence is now overdue. Please consult section 4.2 of the Absence Policy and check the AWOL procedure. Please also make at least 2 attempts to phone the employee and establish their circumstances.",
    YES: "Yes",

    // Manager Self-Service
    MANAGER_SELF_SERVICE: "Manager Self-Service",
    ADD_EDIT_ABSENCES: "Add & Edit Absences",
    ADD_EDIT_ABSENCES_DESCRIPTION:
      "Allow Manager and Full Access users to add, update, and close absences for their employees.",
    CANCEL_ABSENCES: "Cancel Absences",
    CANCEL_ABSENCES_DESCRIPTION:
      "Allow Manager and Full Access users to cancel absences, or edit already cancelled absences, for their employees.",
    NOTIFICATION_ADMIN_DESCRIPTION:
      "Allow Manager and Full Access users to add, update and remove other notification contacts for their employees.",
    NAVIGATOR_FULL_ACCESS_MANUAL_REFERRALS: "Navigator: Full Access Manual Referrals",
    NAVIGATOR_FULL_ACCESS_MANUAL_REFERRALS_DESCRIPTION:
      "Allow Full Access users to trigger manual referrals to a wellbeing provider.",
    NAVIGATOR_MANAGER_MANUAL_REFERRALS: "Navigator: Manager Manual Referrals",
    NAVIGATOR_MANAGER_MANUAL_REFERRALS_DESCRIPTION:
      "Allow Manager & Advanced Users with FULL access to an employee record to manually refer them to a wellbeing provider.",
    ABSENCE_UPDATES: "Absence Updates",
    ACTIVE_DATE: "Active Date",
    YOU_SURE_WANT_CANCEL_ABSENCE_DETAILED_DESCRIPTION:
      "Please confirm the reason for cancelling absence ID {id}?",
    CANCEL_REASON: "Cancel Reason",
    APPEAL: "Appeal",
    APPEALS: "Appeals",
    APPEAL_FORM: "Appeal Form",
    CANCEL_APPEAL: "Cancel Appeal",
    APPEAL_DETAILS: "Appeal Details",
    HEARING_DETAILS: "Hearing Details",
    HEARING_KPI_DAYS: "Hearing KPI (Days)",
    APPEAL_INSTRUCTIONS: "Appeal Notes",
    REASON_FOR_APPEAL: "Reason for Appeal",
    APPEAL_OUTCOME_REASON: "Decision Outcome",
    APPEAL_HEARING_OUTCOME: "Rationale for Hearing Outcome:",
    ATTACH_DOCUMENT: "Attach Document",
    APPEAL_DELETION_COFIRMATION: "Are you sure you want this appeal to be cancelled?",
    CANCEL_APPEAL_COFIRM: "Yes, Cancel Appeal",
    KEEP_APPEAL: "No, Keep Appeal",

    DATE_RECEIVED: "Date Received",
    HEARING_DATE: "Hearing Date",
    HEARING_CHAIRED_BY: "Hearing Chaired By",
    HR_REPRESENTATIVE: "HR Representative",
    APPEAL_OUTCOME: "Appeal Outcome",
    RATIONALE: "Rationale",
    AGREED_AM_LEVEL: "Agreed Absence Monitoring Level",
    UPHELD: "Upheld",
    NOT_UPHELD: "Not Upheld",
    APPEALS_MESSAGE:
      "If enabled, this features allows absence monitoring level placements to be appealed. Doing so will pause the absence monitoring process for an employee and block any new alerts until the alert hearing has been completed.",
    ABSENCE_RECORD_ACCESS: "Absence Record Access",

    // Audit Logs
    ABSENCE_AUDITS_INFORMATION:
      "This audit log lists all updates to absences by Admin users, or Manager and Full Access users that have self-service permissions enabled. Logs are available for the entire service history, but the report can only be run for a 6 month period each time.",
    NOTIFICATION_AUDITS_INFORMATION:
      "This audit log lists all changes to notification contacts by Admin users, or Manager and Full Access users that have self-service permissions enabled. This includes adding, changing and removing contacts. The report can only be run for a 6 month period each time.",
    ABSENCE_ACCESS_AUDITS_INFORMATION:
      "The audit log shows each time a user has accessed another users absence record. As well as the From and To Date , you must also enter either a User ID or Employee ID. The report can only be run to cover a 6 month period each time.",
  },
};
